/*
  * Rollup Vue-Components Library for a landing
  * {@link https://github.com/united-finance/lib-js}
  * {@link https://unitedfinance.io/}
  * @copyright United Finance (@ivn703619)
  * @license MIT
  */
import {styleEnums,format,types,jettonEnums,noiseService}from'@uf-libjs/services';import {IconSvg,ButtonUniversal,ProgressBar,SingleSelectField,BorderedLabel,MoneyField,LoaderChain,RectangularBlock}from'@uf-libjs/components';import {statisticsService,walletService,jettonsService,jettonsPoolService}from'@uf-web/services';import {Line}from'vue-chartjs';import'chartjs-adapter-date-fns';import {Chart,Title,Tooltip,Legend,Filler,LineElement,LinearScale,CategoryScale,PointElement,TimeScale}from'chart.js';import {mapGetters,mapActions}from'vuex';const {
  layoutColors: layoutColors$2
} = styleEnums;
const colors$2 = [layoutColors$2.primary, layoutColors$2.secondary, layoutColors$2.third];
const defaultColor$2 = layoutColors$2.primary;
var script$P = {
  name: 'TheMenu',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: defaultColor$2
    }
  },
  computed: {
    colorClass() {
      const color = colors$2.includes(this.backgroundColor) && this.backgroundColor || defaultColor$2;
      return this.$style[`${color}Color`];
    }
  }
};function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}/* script */
const __vue_script__$P = script$P;

/* template */
var __vue_render__$P = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('nav', {
    class: [_vm.$style.nav, _vm.colorClass, (_obj = {}, _obj[_vm.$style.checked] = _vm.checked, _obj)]
  }, [_c('ul', {
    class: _vm.$style.menu
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.$config.docsPageUri
    }
  }, [_vm._v("\n        Docs\n      ")])])])]);
};
var __vue_staticRenderFns__$P = [];

/* style */
const __vue_inject_styles__$P = function (inject) {
  if (!inject) return;
  inject("data-v-fb6d38d2_0", {
    source: ".src-lib-components-TheLayout-nav-bIOM{top:60px;left:0;width:100%;height:100%;max-height:0;position:fixed;overflow:hidden}.src-lib-components-TheLayout-menu-3tIK a{display:block;padding:24px;color:var(--menu-font-primary);font:var(--f-sb16-mlsh);text-transform:uppercase;letter-spacing:.8px;-webkit-text-decoration:underline .15em transparent;text-decoration:underline .15em transparent}.src-lib-components-TheLayout-menu-3tIK a:focus,.src-lib-components-TheLayout-menu-3tIK a:hover{background-color:var(--menu-background-color-primary-hover)}.src-lib-components-TheLayout-checked-gUsu{max-height:100%;transition:max-height .5s ease-out}.src-lib-components-TheLayout-nav-bIOM.src-lib-components-TheLayout-primaryColor-Rxv1.src-lib-components-TheLayout-checked-gUsu{background-color:var(--menu-background-color-primary)}.src-lib-components-TheLayout-nav-bIOM.src-lib-components-TheLayout-secondaryColor-wB-6.src-lib-components-TheLayout-checked-gUsu{background-color:var(--menu-background-color-secondary)}@media (min-width:768px){.src-lib-components-TheLayout-nav-bIOM{top:0;width:-moz-fit-content;width:fit-content;max-height:70px;position:relative;background-color:transparent}.src-lib-components-TheLayout-menu-3tIK li{float:left}.src-lib-components-TheLayout-menu-3tIK a:focus,.src-lib-components-TheLayout-menu-3tIK a:hover{background-color:transparent;color:var(--menu-font-active);transform:scale(1.1);text-decoration:underline;text-underline-offset:30%}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "nav": "src-lib-components-TheLayout-nav-bIOM",
      "menu": "src-lib-components-TheLayout-menu-3tIK",
      "checked": "src-lib-components-TheLayout-checked-gUsu",
      "primaryColor": "src-lib-components-TheLayout-primaryColor-Rxv1",
      "secondaryColor": "src-lib-components-TheLayout-secondaryColor-wB-6"
    }
  });
};
/* scoped */
const __vue_scope_id__$P = undefined;
/* module identifier */
const __vue_module_identifier__$P = undefined;
/* functional template */
const __vue_is_functional_template__$P = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, createInjector, undefined, undefined);
var TheMenu = __vue_component__$S;const {
  layoutColors: layoutColors$1
} = styleEnums;
const colors$1 = [layoutColors$1.primary, layoutColors$1.secondary, layoutColors$1.third];
const defaultColor$1 = layoutColors$1.primary;
var script$O = {
  name: 'TheHeader',
  components: {
    IconSvg,
    TheMenu
  },
  props: {
    connectButtonId: {
      type: String,
      default() {
        return 'connect-button-default';
      }
    },
    backgroundColor: {
      type: String,
      default: defaultColor$1
    }
  },
  data() {
    return {
      checked: false,
      sideMenuId: 'side-menu'
    };
  },
  computed: {
    colorClass() {
      const color = colors$1.includes(this.backgroundColor) && this.backgroundColor || defaultColor$1;
      return this.$style[`${color}Color`];
    }
  }
};/* script */
const __vue_script__$O = script$O;

/* template */
var __vue_render__$O = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('header', {
    class: _vm.$style.header
  }, [_c('div', {
    class: [_vm.$style.subHeader, (_obj = {}, _obj[_vm.$style.sideMenuChecked] = _vm.checked, _obj), _vm.colorClass]
  }, [_c('div', {
    class: _vm.$style.left
  }, [_c('a', {
    attrs: {
      "href": _vm.$config.landingPageUri
    }
  }, [_c('IconSvg', {
    class: _vm.$style.logo,
    attrs: {
      "png": "uf-logo"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checked,
      expression: "checked"
    }],
    class: _vm.$style.sideMenu,
    attrs: {
      "id": _vm.sideMenuId,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : _vm.checked
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.checked = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.$style.hamb,
    attrs: {
      "for": _vm.sideMenuId
    }
  }, [_c('span', {
    class: _vm.$style.hambLine
  }), _vm._v(" "), _c('span', {
    class: _vm.$style.menuName
  }, [_vm._v("\n          MENU\n        ")])]), _vm._v(" "), _c('TheMenu', {
    class: _vm.$style.menuDesktop,
    attrs: {
      "checked": _vm.checked,
      "background-color": _vm.backgroundColor
    }
  })], 1), _vm._v(" "), _vm._t("buttons", function () {
    return [_c('div', {
      class: _vm.$style.connectButton,
      attrs: {
        "id": _vm.connectButtonId
      }
    })];
  })], 2), _vm._v(" "), _c('TheMenu', {
    class: _vm.$style.menuMobile,
    attrs: {
      "checked": _vm.checked,
      "background-color": _vm.backgroundColor
    }
  })], 1);
};
var __vue_staticRenderFns__$O = [];

/* style */
const __vue_inject_styles__$O = function (inject) {
  if (!inject) return;
  inject("data-v-531880d2_0", {
    source: ".src-lib-components-TheLayout-header-3lLj{box-sizing:border-box}.src-lib-components-TheLayout-subHeader-1mnn{padding:8px 16px;height:-moz-fit-content;height:fit-content;display:flex;justify-content:space-between;align-items:center}.src-lib-components-TheLayout-sideMenuChecked-1_BF.src-lib-components-TheLayout-primaryColor-2w2O{background-color:var(--menu-background-color-primary)}.src-lib-components-TheLayout-sideMenuChecked-1_BF.src-lib-components-TheLayout-secondaryColor-29rB{background-color:var(--menu-background-color-secondary)}.src-lib-components-TheLayout-left-1fmG{display:flex;align-items:center;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}.src-lib-components-TheLayout-logo-2nr5{font-size:41px}.src-lib-components-TheLayout-hamb-2Ouu{display:flex;align-items:center;grid-column-gap:5px;-moz-column-gap:5px;column-gap:5px;cursor:pointer}.src-lib-components-TheLayout-hambLine-eG3S{position:relative;width:24px;height:2px;display:block;background:var(--menu-font-primary)}.src-lib-components-TheLayout-hambLine-eG3S::after,.src-lib-components-TheLayout-hambLine-eG3S::before{position:absolute;width:100%;height:100%;display:block;content:\"\";transition:all .2s ease-out;background:var(--menu-font-primary)}.src-lib-components-TheLayout-hambLine-eG3S::before{top:5px}.src-lib-components-TheLayout-hambLine-eG3S::after{top:-5px}.src-lib-components-TheLayout-menuName-1Qof{color:var(--color-light);font:var(--f-sb16-mlsh)}.src-lib-components-TheLayout-menuMobile-2DVC{display:block}.src-lib-components-TheLayout-menuDesktop-3zlj{display:none}.src-lib-components-TheLayout-sideMenu--NPI{display:none}.src-lib-components-TheLayout-sideMenu--NPI:checked~.src-lib-components-TheLayout-hamb-2Ouu .src-lib-components-TheLayout-hambLine-eG3S{background:0 0}.src-lib-components-TheLayout-sideMenu--NPI:checked~.src-lib-components-TheLayout-hamb-2Ouu .src-lib-components-TheLayout-hambLine-eG3S::before{transform:rotate(-45deg);top:0}.src-lib-components-TheLayout-sideMenu--NPI:checked~.src-lib-components-TheLayout-hamb-2Ouu .src-lib-components-TheLayout-hambLine-eG3S::after{transform:rotate(45deg);top:0}.src-lib-components-TheLayout-connectButton-1vIs{display:flex;align-items:center;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}.src-lib-components-TheLayout-connectButton-1vIs button{min-width:100px;padding-left:0;background-color:transparent;border-radius:8px;box-shadow:none}.src-lib-components-TheLayout-connectButton-1vIs button::before{content:url(/img/dapp/alien-logo.svg);width:40px;height:40px;padding-top:8px}.src-lib-components-TheLayout-connectButton-1vIs button div{color:var(--menu-font-secondary)}.src-lib-components-TheLayout-connectButton-1vIs svg{display:none}@media (min-width:768px){.src-lib-components-TheLayout-subHeader-1mnn{padding:0 16px}.src-lib-components-TheLayout-hamb-2Ouu{display:none}.src-lib-components-TheLayout-menuMobile-2DVC{display:none}.src-lib-components-TheLayout-menuDesktop-3zlj{display:block}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-lib-components-TheLayout-header-3lLj",
      "subHeader": "src-lib-components-TheLayout-subHeader-1mnn",
      "sideMenuChecked": "src-lib-components-TheLayout-sideMenuChecked-1_BF",
      "primaryColor": "src-lib-components-TheLayout-primaryColor-2w2O",
      "secondaryColor": "src-lib-components-TheLayout-secondaryColor-29rB",
      "left": "src-lib-components-TheLayout-left-1fmG",
      "logo": "src-lib-components-TheLayout-logo-2nr5",
      "hamb": "src-lib-components-TheLayout-hamb-2Ouu",
      "hambLine": "src-lib-components-TheLayout-hambLine-eG3S",
      "menuName": "src-lib-components-TheLayout-menuName-1Qof",
      "menuMobile": "src-lib-components-TheLayout-menuMobile-2DVC",
      "menuDesktop": "src-lib-components-TheLayout-menuDesktop-3zlj",
      "sideMenu": "src-lib-components-TheLayout-sideMenu--NPI",
      "connectButton": "src-lib-components-TheLayout-connectButton-1vIs"
    }
  });
};
/* scoped */
const __vue_scope_id__$O = undefined;
/* module identifier */
const __vue_module_identifier__$O = undefined;
/* functional template */
const __vue_is_functional_template__$O = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, createInjector, undefined, undefined);
var TheHeader = __vue_component__$R;var script$N = {
  name: 'LandingHeader',
  components: {
    ButtonUniversal,
    TheHeader
  },
  data() {
    return {
      isComingSoon: true,
      layoutColor: styleEnums.layoutColors.secondary
    };
  },
  methods: {
    goToDApp() {
      window.open(this.$config.dappPageUri, '_self');
    }
  }
};/* script */
const __vue_script__$N = script$N;

/* template */
var __vue_render__$N = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('TheHeader', {
    class: _vm.$style.header,
    attrs: {
      "background-color": _vm.layoutColor
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.isComingSoon ? _c('ButtonUniversal', {
          class: _vm.$style.goToDAppButton,
          attrs: {
            "color": "stub"
          }
        }, [_vm._v("\n      Coming soon\n    ")]) : _c('ButtonUniversal', {
          class: _vm.$style.goToDAppButton,
          attrs: {
            "color": "enter"
          },
          on: {
            "click": _vm.goToDApp
          }
        }, [_vm._v("\n      Go to DApp\n    ")])];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$N = [];

/* style */
const __vue_inject_styles__$N = function (inject) {
  if (!inject) return;
  inject("data-v-9442be1c_0", {
    source: ".src-lib-components-TheLanding-header-3-WT{position:fixed;top:0;width:100%;max-width:1920px}.src-lib-components-TheLanding-goToDAppButton-2xsD{box-sizing:border-box;height:40px;padding:15px 8px 20px 8px;display:flex;align-items:center;float:right;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}@media only screen and (min-width:1920px){.src-lib-components-TheLanding-header-3-WT{padding:0 320px}}@media only screen and (min-width:769px) and (max-width:1919px){.src-lib-components-TheLanding-header-3-WT{padding:0 72px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-lib-components-TheLanding-header-3-WT",
      "goToDAppButton": "src-lib-components-TheLanding-goToDAppButton-2xsD"
    }
  });
};
/* scoped */
const __vue_scope_id__$N = undefined;
/* module identifier */
const __vue_module_identifier__$N = undefined;
/* functional template */
const __vue_is_functional_template__$N = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, createInjector, undefined, undefined);
var LandingHeader = __vue_component__$Q;const {
  layoutColors
} = styleEnums;
const colors = [layoutColors.primary, layoutColors.secondary, layoutColors.third];
const defaultColor = layoutColors.primary;
var script$M = {
  name: 'TheLayout',
  components: {
    TheHeader
  },
  props: {
    backgroundColor: {
      type: String,
      default: defaultColor
    }
  },
  data() {
    return {
      thresholdHeight: 80,
      isFilled: false
    };
  },
  computed: {
    colorClass() {
      const color = colors.includes(this.backgroundColor) && this.backgroundColor || defaultColor;
      return this.$style[`${color}Color`];
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      const {
        body,
        documentElement
      } = document;
      if (body.scrollTop > this.thresholdHeight || documentElement.scrollTop > this.thresholdHeight) {
        this.isFilled = true;
      } else {
        this.isFilled = false;
      }
    }
  }
};/* script */
const __vue_script__$M = script$M;

/* template */
var __vue_render__$M = function () {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    ref: "header",
    class: [_vm.$style.header, (_obj = {}, _obj[_vm.colorClass] = _vm.isFilled, _obj)]
  }, [_vm._t("header", function () {
    return [_c('TheHeader')];
  })], 2), _vm._v(" "), _c('main', [_vm._t("default")], 2), _vm._v(" "), _vm._t("footer", function () {
    return [_c('footer')];
  })], 2);
};
var __vue_staticRenderFns__$M = [];

/* style */
const __vue_inject_styles__$M = function (inject) {
  if (!inject) return;
  inject("data-v-1253ae60_0", {
    source: "",
    map: undefined,
    media: undefined
  }), inject("data-v-1253ae60_1", {
    source: ".src-lib-components-block-3L9T{max-width:1920px;margin:auto}.src-lib-components-header-16CE{position:sticky;top:0;width:100%;max-width:1920px;margin:auto;box-sizing:border-box;z-index:1}.src-lib-components-header-16CE.src-lib-components-primaryColor-17-F,.src-lib-components-header-16CE.src-lib-components-primaryColor-17-F>header{background-color:var(--menu-background-color-primary)}.src-lib-components-header-16CE.src-lib-components-secondaryColor-2y20,.src-lib-components-header-16CE.src-lib-components-secondaryColor-2y20>header{background-color:var(--menu-background-color-secondary)}.src-lib-components-header-16CE.src-lib-components-thirdColor-1Cgt,.src-lib-components-header-16CE.src-lib-components-thirdColor-1Cgt>header{background-color:var(--menu-background-color-third)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-block-3L9T",
      "header": "src-lib-components-header-16CE",
      "primaryColor": "src-lib-components-primaryColor-17-F",
      "secondaryColor": "src-lib-components-secondaryColor-2y20",
      "thirdColor": "src-lib-components-thirdColor-1Cgt"
    }
  });
};
/* scoped */
const __vue_scope_id__$M = undefined;
/* module identifier */
const __vue_module_identifier__$M = undefined;
/* functional template */
const __vue_is_functional_template__$M = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, createInjector, undefined, undefined);
var TheLayout = __vue_component__$P;var script$L = {
  name: 'LandingMainBlock'
};/* script */
const __vue_script__$L = script$L;

/* template */
var __vue_render__$L = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('section', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.blockText
  }, [_c('div', {
    class: _vm.$style.blockTextMain
  }, [_vm._v("\n      United Finance: simplicity and expertise for\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.blockTextSecondary
  }, [_vm._v("\n      maximizing yield on TON\n    ")])])]);
};
var __vue_staticRenderFns__$L = [];

/* style */
const __vue_inject_styles__$L = function (inject) {
  if (!inject) return;
  inject("data-v-2ad1f71d_0", {
    source: ".src-lib-components-TheLanding-block-qkXx{margin:auto;max-width:1920px;height:640px;display:flex;justify-content:flex-start;align-items:flex-end;background-color:var(--menu-background-color-secondary);border-radius:0 0 72px 72px;box-shadow:none!important}.src-lib-components-TheLanding-blockText-2Ihg{max-width:570px;margin-bottom:108px}.src-lib-components-TheLanding-blockTextMain-1ZLL{width:568px;color:var(--color-light);font:var(--f-48-mlsh)}.src-lib-components-TheLanding-blockTextSecondary-2kui{width:482px;color:var(--color-active);font:var(--f-48i-mlsh);font-style:italic}@media only screen and (min-width:1920px){.src-lib-components-TheLanding-block-qkXx{padding:0 320px}.src-lib-components-TheLanding-block-qkXx{background-image:url(/img/landing/landing-waves-1920.png);background-repeat:no-repeat;background-position:right}}@media only screen and (min-width:769px) and (max-width:1919px){.src-lib-components-TheLanding-block-qkXx{padding:0 72px}.src-lib-components-TheLanding-block-qkXx{background-image:url(/img/landing/landing-waves-1440.png);background-repeat:no-repeat;background-position:right}}@media only screen and (max-width:768px){.src-lib-components-TheLanding-block-qkXx{height:448px;background-image:url(/img/landing/landing-waves-360.png);background-repeat:no-repeat;background-position:right}.src-lib-components-TheLanding-blockText-2Ihg{margin-left:32px;margin-bottom:64px}.src-lib-components-TheLanding-blockTextMain-1ZLL{width:287px;font:var(--f-32-mlsh)}.src-lib-components-TheLanding-blockTextSecondary-2kui{width:201px;font:var(--f-32i-mlsh)}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-block-qkXx",
      "blockText": "src-lib-components-TheLanding-blockText-2Ihg",
      "blockTextMain": "src-lib-components-TheLanding-blockTextMain-1ZLL",
      "blockTextSecondary": "src-lib-components-TheLanding-blockTextSecondary-2kui"
    }
  });
};
/* scoped */
const __vue_scope_id__$L = undefined;
/* module identifier */
const __vue_module_identifier__$L = undefined;
/* functional template */
const __vue_is_functional_template__$L = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, createInjector, undefined, undefined);
var LandingMainBlock = __vue_component__$O;var script$K = {
  name: 'LandingProtocolDescription',
  components: {
    IconSvg
  }
};/* script */
const __vue_script__$K = script$K;

/* template */
var __vue_render__$K = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('section', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.blockText
  }, [_c('div', [_vm._v("\n      Introducing yield aggregation protocol that simplifies and enhances the experience of earning yield on the TON blockchain.\n    ")]), _vm._v(" "), _c('div', [_vm._v("\n      United Finance is designed to provide a user-friendly interface for depositing crypto assets into yield-generating strategies, automatically distributing the earned yield to users' wallets.\n    ")]), _vm._v(" "), _c('div', [_vm._v("\n      At the moment, the protocol's primary product is wuTON, a yield-bearing token that is fully backed by TON. United Finance is constantly evolving and expanding its product offerings, with plans to introduce a wider range of yield-bearing products in the future.\n    ")])]), _vm._v(" "), _c('IconSvg', {
    class: _vm.$style.uuArrowIcon,
    attrs: {
      "png": "uu-arrow"
    }
  })], 1);
};
var __vue_staticRenderFns__$K = [];

/* style */
const __vue_inject_styles__$K = function (inject) {
  if (!inject) return;
  inject("data-v-3d6c76ca_0", {
    source: ".src-lib-components-TheLanding-block-2MpH{position:relative;max-width:1264px;margin:auto;display:flex;justify-content:space-between;align-items:flex-end;background-color:var(--background-color-active);border-radius:0 0 116px 116px}.src-lib-components-TheLanding-block-2MpH::after{content:\"\";position:absolute;background:var(--background-color-active);top:-40px;right:-40px;bottom:-40px;left:-40px;top:-100px;bottom:0;left:0;right:0;z-index:-1;border-radius:0 0 116px 116px}.src-lib-components-TheLanding-blockText-76eG{display:flex;flex-direction:column;grid-row-gap:32px;row-gap:32px;padding:80px 96px 90px 112px;color:var(--color-description);font:var(--f-20-mlsh)}.src-lib-components-TheLanding-uuArrowIcon-3-WF{font-size:525px}div.src-lib-components-TheLanding-uuArrowIcon-3-WF{height:.91em}@media only screen and (max-width:768px){.src-lib-components-TheLanding-block-2MpH{border-radius:0 0 72px 72px}.src-lib-components-TheLanding-blockText-76eG{grid-row-gap:24px;row-gap:24px;font:var(--f-16-mlsh)}.src-lib-components-TheLanding-uuArrowIcon-3-WF{font-size:245px}}@media only screen and (max-width:1090px){.src-lib-components-TheLanding-block-2MpH{flex-direction:column;align-items:center}.src-lib-components-TheLanding-blockText-76eG{padding:60px 48px 8px 48px}.src-lib-components-TheLanding-uuArrowIcon-3-WF{margin:0 48px 23px 48px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-block-2MpH",
      "blockText": "src-lib-components-TheLanding-blockText-76eG",
      "uuArrowIcon": "src-lib-components-TheLanding-uuArrowIcon-3-WF"
    }
  });
};
/* scoped */
const __vue_scope_id__$K = undefined;
/* module identifier */
const __vue_module_identifier__$K = undefined;
/* functional template */
const __vue_is_functional_template__$K = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, createInjector, undefined, undefined);
var LandingProtocolDescription = __vue_component__$N;var script$J = {
  name: 'UniversalBlock'
};/* script */
const __vue_script__$J = script$J;

/* template */
var __vue_render__$J = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$J = [];

/* style */
const __vue_inject_styles__$J = function (inject) {
  if (!inject) return;
  inject("data-v-ed706254_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-block-agjJ{box-sizing:border-box;min-width:400px;max-width:400px;min-height:490px;padding:40px;background-color:var(--background-color-primary);border-radius:var(--br-medium);box-shadow:0 4px 16px 0 var(--box-shadow-color-primary)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-ProtocolFeatures-block-agjJ"
    }
  });
};
/* scoped */
const __vue_scope_id__$J = undefined;
/* module identifier */
const __vue_module_identifier__$J = undefined;
/* functional template */
const __vue_is_functional_template__$J = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, createInjector, undefined, undefined);
var UniversalBlock = __vue_component__$M;var script$I = {
  name: 'FeatureBlock',
  components: {
    UniversalBlock
  }
};/* script */
const __vue_script__$I = script$I;

/* template */
var __vue_render__$I = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('UniversalBlock', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.icon
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    class: _vm.$style.header
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    class: _vm.$style.description
  }, [_vm._t("description")], 2)]);
};
var __vue_staticRenderFns__$I = [];

/* style */
const __vue_inject_styles__$I = function (inject) {
  if (!inject) return;
  inject("data-v-95755c16_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-block-3LtD{height:100%}.src-lib-components-TheLanding-ProtocolFeatures-icon-VJN1{min-height:66px}.src-lib-components-TheLanding-ProtocolFeatures-header-1V6e{margin-top:16px;color:var(--color-header);font:var(--f-b24-mlsh)}.src-lib-components-TheLanding-ProtocolFeatures-description-7pNn{margin-top:16px;color:var(--color-description-secondary);font:var(--f-16-mlsh)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-ProtocolFeatures-block-3LtD",
      "icon": "src-lib-components-TheLanding-ProtocolFeatures-icon-VJN1",
      "header": "src-lib-components-TheLanding-ProtocolFeatures-header-1V6e",
      "description": "src-lib-components-TheLanding-ProtocolFeatures-description-7pNn"
    }
  });
};
/* scoped */
const __vue_scope_id__$I = undefined;
/* module identifier */
const __vue_module_identifier__$I = undefined;
/* functional template */
const __vue_is_functional_template__$I = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, createInjector, undefined, undefined);
var FeatureBlock = __vue_component__$L;var script$H = {
  name: 'FeatureBlock1',
  components: {
    IconSvg,
    FeatureBlock
  }
};/* script */
const __vue_script__$H = script$H;

/* template */
var __vue_render__$H = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('FeatureBlock', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('IconSvg', {
          class: _vm.$style.icon,
          attrs: {
            "png": "feature-lightning"
          }
        })];
      },
      proxy: true
    }, {
      key: "header",
      fn: function () {
        return [_vm._v("\n    Eliminate the complexity of earning yield\n  ")];
      },
      proxy: true
    }, {
      key: "description",
      fn: function () {
        return [_vm._v("\n    United Finance eliminates the complexity of manually navigating various DeFi protocols for yield. The protocol allows you to earn passive income on your TON without requiring expert knowledge of DeFi.\n  ")];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$H = [];

/* style */
const __vue_inject_styles__$H = function (inject) {
  if (!inject) return;
  inject("data-v-f5bf2f60_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-1Twb{font-size:112px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "icon": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-1Twb"
    }
  });
};
/* scoped */
const __vue_scope_id__$H = undefined;
/* module identifier */
const __vue_module_identifier__$H = undefined;
/* functional template */
const __vue_is_functional_template__$H = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, createInjector, undefined, undefined);
var FeatureBlock1 = __vue_component__$K;var script$G = {
  name: 'FeatureBlock2',
  components: {
    IconSvg,
    FeatureBlock
  }
};/* script */
const __vue_script__$G = script$G;

/* template */
var __vue_render__$G = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('FeatureBlock', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('IconSvg', {
          class: _vm.$style.icon,
          attrs: {
            "png": "feature-square"
          }
        })];
      },
      proxy: true
    }, {
      key: "header",
      fn: function () {
        return [_vm._v("\n    Strategies selection and allocation is done by the protocol\n  ")];
      },
      proxy: true
    }, {
      key: "description",
      fn: function () {
        return [_vm._v("\n    United Finance allocates your funds to the safest and most profitable yield-generating strategies, ensuring that you maximize your earnings potential. This eliminates the need for you to manually research and manage different protocols.\n  ")];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$G = [];

/* style */
const __vue_inject_styles__$G = function (inject) {
  if (!inject) return;
  inject("data-v-2937426f_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-19zd{font-size:112px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "icon": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-19zd"
    }
  });
};
/* scoped */
const __vue_scope_id__$G = undefined;
/* module identifier */
const __vue_module_identifier__$G = undefined;
/* functional template */
const __vue_is_functional_template__$G = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, createInjector, undefined, undefined);
var FeatureBlock2 = __vue_component__$J;var script$F = {
  name: 'FeatureBlock3',
  components: {
    IconSvg,
    FeatureBlock
  }
};/* script */
const __vue_script__$F = script$F;

/* template */
var __vue_render__$F = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('FeatureBlock', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('IconSvg', {
          class: _vm.$style.icon,
          attrs: {
            "png": "feature-graph"
          }
        })];
      },
      proxy: true
    }, {
      key: "header",
      fn: function () {
        return [_vm._v("\n    Instant yield distribution\n  ")];
      },
      proxy: true
    }, {
      key: "description",
      fn: function () {
        return [_vm._v("\n    All yield generated by the strategies is immediately distributed by appreciating the value of wuTON tokens. This ensures that you reap the benefits of your investments promptly and seamlessly.\n  ")];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$F = [];

/* style */
const __vue_inject_styles__$F = function (inject) {
  if (!inject) return;
  inject("data-v-122183b0_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-1uyQ{font-size:112px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "icon": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-1uyQ"
    }
  });
};
/* scoped */
const __vue_scope_id__$F = undefined;
/* module identifier */
const __vue_module_identifier__$F = undefined;
/* functional template */
const __vue_is_functional_template__$F = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, createInjector, undefined, undefined);
var FeatureBlock3 = __vue_component__$I;var script$E = {
  name: 'FeatureBlock4',
  components: {
    IconSvg,
    FeatureBlock
  }
};/* script */
const __vue_script__$E = script$E;

/* template */
var __vue_render__$E = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('FeatureBlock', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('IconSvg', {
          class: _vm.$style.icon,
          attrs: {
            "png": "feature-wuton"
          }
        })];
      },
      proxy: true
    }, {
      key: "header",
      fn: function () {
        return [_vm._v("\n    Liquid yield generating token\n  ")];
      },
      proxy: true
    }, {
      key: "description",
      fn: function () {
        return [_vm._v("\n    wuTON is a liquid yield-generating token, usable like any other token and compatible with other DeFi protocols.\n  ")];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$E = [];

/* style */
const __vue_inject_styles__$E = function (inject) {
  if (!inject) return;
  inject("data-v-15039d93_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-1cy4{font-size:112px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "icon": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-1cy4"
    }
  });
};
/* scoped */
const __vue_scope_id__$E = undefined;
/* module identifier */
const __vue_module_identifier__$E = undefined;
/* functional template */
const __vue_is_functional_template__$E = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, createInjector, undefined, undefined);
var FeatureBlock4 = __vue_component__$H;var script$D = {
  name: 'FeatureBlock5',
  components: {
    IconSvg,
    FeatureBlock
  }
};/* script */
const __vue_script__$D = script$D;

/* template */
var __vue_render__$D = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('FeatureBlock', {
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('IconSvg', {
          class: _vm.$style.icon,
          attrs: {
            "png": "feature-triangle"
          }
        })];
      },
      proxy: true
    }, {
      key: "header",
      fn: function () {
        return [_vm._v("\n    More products for more use cases\n  ")];
      },
      proxy: true
    }, {
      key: "description",
      fn: function () {
        return [_vm._v("\n    wuTON is the first product of the protocol. United Finance is evolving and will offer more different products in the future, including yield-bearing stablecoins.\n  ")];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$D = [];

/* style */
const __vue_inject_styles__$D = function (inject) {
  if (!inject) return;
  inject("data-v-4df837ac_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-ZUeF{font-size:112px}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "icon": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-icon-ZUeF"
    }
  });
};
/* scoped */
const __vue_scope_id__$D = undefined;
/* module identifier */
const __vue_module_identifier__$D = undefined;
/* functional template */
const __vue_is_functional_template__$D = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, createInjector, undefined, undefined);
var FeatureBlock5 = __vue_component__$G;var script$C = {
  name: 'FeatureBlock6',
  components: {
    IconSvg,
    ButtonUniversal,
    UniversalBlock
  },
  data() {
    return {
      isComingSoon: true
    };
  },
  methods: {
    goToDApp() {
      window.open(this.$config.dappPageUri, '_self');
    }
  }
};/* script */
const __vue_script__$C = script$C;

/* template */
var __vue_render__$C = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('UniversalBlock', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.alienIconBlock
  }, [_c('IconSvg', {
    class: _vm.$style.alienIcon,
    attrs: {
      "png": "alien-hand"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.goToDAppButtonBlock
  }, [_vm.isComingSoon ? _c('ButtonUniversal', {
    class: _vm.$style.goToDAppButton,
    attrs: {
      "color": "stub"
    }
  }, [_vm._v("\n      Coming soon\n    ")]) : _c('ButtonUniversal', {
    class: _vm.$style.goToDAppButton,
    attrs: {
      "color": "enterSecondary"
    },
    on: {
      "click": _vm.goToDApp
    }
  }, [_vm._v("\n      Go to DApp\n    ")])], 1)]);
};
var __vue_staticRenderFns__$C = [];

/* style */
const __vue_inject_styles__$C = function (inject) {
  if (!inject) return;
  inject("data-v-5163fa3c_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-Blocks-block-2Cos{height:100%;display:flex;flex-direction:column;justify-content:center}.src-lib-components-TheLanding-ProtocolFeatures-Blocks-alienIconBlock-2quL{display:flex;justify-content:center}.src-lib-components-TheLanding-ProtocolFeatures-Blocks-alienIcon-xTp8{font-size:212px}.src-lib-components-TheLanding-ProtocolFeatures-Blocks-goToDAppButtonBlock-2x1e{margin-top:24px;display:flex;justify-content:center}.src-lib-components-TheLanding-ProtocolFeatures-Blocks-goToDAppButton-12fI{padding:16px 48px;font:var(--f-b18-mlsh)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-block-2Cos",
      "alienIconBlock": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-alienIconBlock-2quL",
      "alienIcon": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-alienIcon-xTp8",
      "goToDAppButtonBlock": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-goToDAppButtonBlock-2x1e",
      "goToDAppButton": "src-lib-components-TheLanding-ProtocolFeatures-Blocks-goToDAppButton-12fI"
    }
  });
};
/* scoped */
const __vue_scope_id__$C = undefined;
/* module identifier */
const __vue_module_identifier__$C = undefined;
/* functional template */
const __vue_is_functional_template__$C = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, createInjector, undefined, undefined);
var FeatureBlock6 = __vue_component__$F;var script$B = {
  name: 'FeaturesSlider',
  components: {
    IconSvg
  },
  props: {
    slideSlots: {
      type: Array,
      default() {
        return [{
          id: 1
        }, {
          id: 2
        }, {
          id: 3
        }];
      }
    }
  },
  data() {
    return {
      posX1: 0,
      posX2: 0,
      posInitial: 0,
      posFinal: 0,
      threshold: 100,
      slideSize: 0,
      slidesLength: 0,
      index: 0,
      allowShift: false,
      items: null,
      dots: null
    };
  },
  mounted() {
    this.items = this.$refs.slides;
    const {
      slider,
      prev,
      next,
      dots
    } = this.$refs;
    this.dots = dots.getElementsByClassName(this.$style.dots);
    this.slide(slider, prev, next);
  },
  methods: {
    slide(wrapper, prev, next) {
      const slides = this.items.getElementsByClassName(this.$style.slide);
      this.slidesLength = slides.length;
      this.slideSize = this.items.getElementsByClassName(this.$style.slide)[0].offsetWidth;
      const firstSlide = slides[0];
      const lastSlide = slides[this.slidesLength - 1];
      const cloneFirst = firstSlide.cloneNode(true);
      const cloneLast = lastSlide.cloneNode(true);
      this.allowShift = true;

      // Clone first and last slide
      this.items.appendChild(cloneFirst);
      this.items.insertBefore(cloneLast, firstSlide);

      // Mouse events
      this.items.onmousedown = this.dragStart;

      // Touch events
      // this.items.addEventListener('touchstart', this.dragStart);
      // this.items.addEventListener('touchend', this.dragEnd);
      // this.items.addEventListener('touchmove', this.dragAction);

      // Click events
      prev.addEventListener('click', () => {
        this.shiftSlide(-1);
      });
      next.addEventListener('click', () => {
        this.shiftSlide(1);
      });

      // Transition events
      this.items.addEventListener('transitionend', this.checkIndex);
      this.markDot();
    },
    dragStart(e) {
      e = e || window.event;
      e.preventDefault();
      this.posInitial = this.items.offsetLeft;
      if (e.type === 'touchstart') {
        this.posX1 = e.touches[0].clientX;
      } else {
        this.posX1 = e.clientX;
        document.onmouseup = this.dragEnd;
        document.onmousemove = this.dragAction;
      }
    },
    dragAction(e) {
      e = e || window.event;
      console.log(e);
      if (e.type === 'touchmove') {
        this.posX2 = this.posX1 - e.touches[0].clientX;
        this.posX1 = e.touches[0].clientX;
      } else {
        this.posX2 = this.posX1 - e.clientX;
        this.posX1 = e.clientX;
      }
      this.items.style.left = `${this.items.offsetLeft - this.posX2}px`;
    },
    dragEnd(e) {
      this.posFinal = this.items.offsetLeft;
      if (this.posFinal - this.posInitial < -this.threshold) {
        this.shiftSlide(1, 'drag');
      } else if (this.posFinal - this.posInitial > this.threshold) {
        this.shiftSlide(-1, 'drag');
      } else {
        this.items.style.left = `${this.posInitial}px`;
      }
      document.onmouseup = null;
      document.onmousemove = null;
    },
    shiftSlide(dir, action) {
      this.items.classList.add(this.$style.shifting);
      if (this.allowShift) {
        if (!action) {
          this.posInitial = this.items.offsetLeft;
        }
        this.resetDot();
        if (dir === 1) {
          this.items.style.left = `${this.posInitial - this.slideSize}px`;
          this.index++;
        } else if (dir === -1) {
          this.items.style.left = `${this.posInitial + this.slideSize}px`;
          this.index--;
        } else if (dir > 1 || dir < -1) {
          this.items.style.left = `${this.posInitial - this.slideSize * dir}px`;
          this.index += dir;
        }
      }
      this.allowShift = false;
    },
    checkIndex() {
      this.items.classList.remove(this.$style.shifting);
      if (this.index === -1) {
        this.items.style.left = `${-(this.slidesLength * this.slideSize)}px`;
        this.index = this.slidesLength - 1;
      }
      if (this.index === this.slidesLength) {
        this.items.style.left = `${-(1 * this.slideSize)}px`;
        this.index = 0;
      }
      this.markDot();
      this.allowShift = true;
    },
    currentSlide(currentIndex) {
      const shift = currentIndex - this.index;
      this.shiftSlide(shift);
    },
    markDot() {
      this.dots[this.index].classList.add(this.$style.enable);
    },
    resetDot() {
      this.dots[this.index].classList.remove(this.$style.enable);
    }
  }
};/* script */
const __vue_script__$B = script$B;

/* template */
var __vue_render__$B = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "slider",
    class: _vm.$style.slider
  }, [_c('div', {
    class: _vm.$style.wrapper
  }, [_c('div', {
    ref: "slides",
    class: _vm.$style.slides
  }, _vm._l(_vm.slideSlots, function (slideSlot) {
    return _c('div', {
      key: slideSlot.id,
      class: _vm.$style.slide
    }, [_vm._t("slide_" + slideSlot.id)], 2);
  }), 0)]), _vm._v(" "), _c('a', {
    ref: "prev",
    class: [_vm.$style.control, _vm.$style.prev]
  }, [_c('IconSvg', {
    class: _vm.$style.iconPrev,
    attrs: {
      "png": "next"
    }
  })], 1), _vm._v(" "), _c('a', {
    ref: "next",
    class: [_vm.$style.control, _vm.$style.next]
  }, [_c('IconSvg', {
    class: _vm.$style.iconNext,
    attrs: {
      "png": "next"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "dots",
    class: _vm.$style.wrapperDots
  }, _vm._l(_vm.slideSlots, function (_, ind) {
    return _c('span', {
      key: ind,
      class: _vm.$style.dots,
      on: {
        "click": function ($event) {
          return _vm.currentSlide(ind);
        }
      }
    });
  }), 0)]);
};
var __vue_staticRenderFns__$B = [];

/* style */
const __vue_inject_styles__$B = function (inject) {
  if (!inject) return;
  inject("data-v-77e75991_0", {
    source: ".src-lib-components-TheLanding-ProtocolFeatures-slider-3l7p{position:relative;width:283px;height:610px;background-color:transparent}.src-lib-components-TheLanding-ProtocolFeatures-wrapper-209a{overflow:hidden;position:relative;width:283px;height:610px;background-color:transparent}.src-lib-components-TheLanding-ProtocolFeatures-slides-5DJ5{display:flex;position:relative;top:0;left:-283px;width:10000px}.src-lib-components-TheLanding-ProtocolFeatures-slide-2x-B{width:283px;height:610px;cursor:pointer;display:flex;flex-direction:column;justify-content:center;align-items:center;transition:all 1s;position:relative;border-radius:2px}.src-lib-components-TheLanding-ProtocolFeatures-slides-5DJ5.src-lib-components-TheLanding-ProtocolFeatures-shifting-1RqR{transition:left .2s ease-out}.src-lib-components-TheLanding-ProtocolFeatures-control-2vu6{position:absolute;top:50%;width:50px;height:50px;background:var(--background-color-primary);border-radius:50px;margin-top:-20px;box-shadow:1px 1px 10px rgba(0,0,0,.3)}.src-lib-components-TheLanding-ProtocolFeatures-next-2gDT,.src-lib-components-TheLanding-ProtocolFeatures-prev-2itF{background-size:22px;background-position:center;background-repeat:no-repeat;cursor:pointer}.src-lib-components-TheLanding-ProtocolFeatures-prev-2itF{left:-20px}.src-lib-components-TheLanding-ProtocolFeatures-next-2gDT{right:-20px}.src-lib-components-TheLanding-ProtocolFeatures-iconPrev-1f1l{font-size:50px;transform:rotate(180deg)}.src-lib-components-TheLanding-ProtocolFeatures-iconNext-3qyE{font-size:50px}.src-lib-components-TheLanding-ProtocolFeatures-next-2gDT:active,.src-lib-components-TheLanding-ProtocolFeatures-prev-2itF:active{transform:scale(.8)}.src-lib-components-TheLanding-ProtocolFeatures-wrapperDots-E7FR{margin-top:22px;display:flex;justify-content:center}.src-lib-components-TheLanding-ProtocolFeatures-dots-1ol_{cursor:pointer;height:16px;width:16px;margin:0 3px;opacity:.3;border-radius:50%;display:inline-block;transition:background-color .5s ease;border:1px solid var(--slider-dots-border-color);background-color:var(--slider-dots-background-color-unchecked)}.src-lib-components-TheLanding-ProtocolFeatures-dots-1ol_:hover,.src-lib-components-TheLanding-ProtocolFeatures-enable-7SZR{background-color:var(--slider-dots-background-color-checked);opacity:1}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "slider": "src-lib-components-TheLanding-ProtocolFeatures-slider-3l7p",
      "wrapper": "src-lib-components-TheLanding-ProtocolFeatures-wrapper-209a",
      "slides": "src-lib-components-TheLanding-ProtocolFeatures-slides-5DJ5",
      "slide": "src-lib-components-TheLanding-ProtocolFeatures-slide-2x-B",
      "shifting": "src-lib-components-TheLanding-ProtocolFeatures-shifting-1RqR",
      "control": "src-lib-components-TheLanding-ProtocolFeatures-control-2vu6",
      "prev": "src-lib-components-TheLanding-ProtocolFeatures-prev-2itF",
      "next": "src-lib-components-TheLanding-ProtocolFeatures-next-2gDT",
      "iconPrev": "src-lib-components-TheLanding-ProtocolFeatures-iconPrev-1f1l",
      "iconNext": "src-lib-components-TheLanding-ProtocolFeatures-iconNext-3qyE",
      "wrapperDots": "src-lib-components-TheLanding-ProtocolFeatures-wrapperDots-E7FR",
      "dots": "src-lib-components-TheLanding-ProtocolFeatures-dots-1ol_",
      "enable": "src-lib-components-TheLanding-ProtocolFeatures-enable-7SZR"
    }
  });
};
/* scoped */
const __vue_scope_id__$B = undefined;
/* module identifier */
const __vue_module_identifier__$B = undefined;
/* functional template */
const __vue_is_functional_template__$B = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, createInjector, undefined, undefined);
var Slider = __vue_component__$E;var script$A = {
  name: 'LandingProtocolFeatures',
  components: {
    FeatureBlock1,
    FeatureBlock2,
    FeatureBlock3,
    FeatureBlock4,
    FeatureBlock5,
    FeatureBlock6,
    Slider
  },
  data() {
    return {
      blocks: [...Array(6).keys()].map(x => ({
        id: x + 1
      }))
    };
  }
};/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('section', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.grid
  }, [_c('FeatureBlock1'), _vm._v(" "), _c('FeatureBlock2'), _vm._v(" "), _c('FeatureBlock3'), _vm._v(" "), _c('FeatureBlock4'), _vm._v(" "), _c('FeatureBlock5'), _vm._v(" "), _c('FeatureBlock6')], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.carousel
  }, [_c('Slider', {
    attrs: {
      "slide-slots": _vm.blocks
    },
    scopedSlots: _vm._u([{
      key: "slide_1",
      fn: function () {
        return [_c('FeatureBlock1', {
          class: _vm.$style.blockThin
        })];
      },
      proxy: true
    }, {
      key: "slide_2",
      fn: function () {
        return [_c('FeatureBlock2', {
          class: _vm.$style.blockThin
        })];
      },
      proxy: true
    }, {
      key: "slide_3",
      fn: function () {
        return [_c('FeatureBlock3', {
          class: _vm.$style.blockThin
        })];
      },
      proxy: true
    }, {
      key: "slide_4",
      fn: function () {
        return [_c('FeatureBlock4', {
          class: _vm.$style.blockThin
        })];
      },
      proxy: true
    }, {
      key: "slide_5",
      fn: function () {
        return [_c('FeatureBlock5', {
          class: _vm.$style.blockThin
        })];
      },
      proxy: true
    }, {
      key: "slide_6",
      fn: function () {
        return [_c('FeatureBlock6', {
          class: _vm.$style.blockThin
        })];
      },
      proxy: true
    }])
  })], 1)]);
};
var __vue_staticRenderFns__$A = [];

/* style */
const __vue_inject_styles__$A = function (inject) {
  if (!inject) return;
  inject("data-v-7e6b7d21_0", {
    source: ".src-lib-components-TheLanding-block-ct8a{max-width:1264px;margin:auto}.src-lib-components-TheLanding-grid-1Oxi{display:flex;flex-wrap:wrap;justify-content:center;grid-column-gap:32px;-moz-column-gap:32px;column-gap:32px;grid-row-gap:32px;row-gap:32px}.src-lib-components-TheLanding-blockThin-2tP8{min-width:283px!important;max-width:283px!important;min-height:526px!important}.src-lib-components-TheLanding-carousel-T2xK{display:none}@media only screen and (max-width:430px){.src-lib-components-TheLanding-grid-1Oxi{display:none}.src-lib-components-TheLanding-carousel-T2xK{display:flex;justify-content:center}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-block-ct8a",
      "grid": "src-lib-components-TheLanding-grid-1Oxi",
      "blockThin": "src-lib-components-TheLanding-blockThin-2tP8",
      "carousel": "src-lib-components-TheLanding-carousel-T2xK"
    }
  });
};
/* scoped */
const __vue_scope_id__$A = undefined;
/* module identifier */
const __vue_module_identifier__$A = undefined;
/* functional template */
const __vue_is_functional_template__$A = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, createInjector, undefined, undefined);
var LandingProtocolFeatures = __vue_component__$D;var script$z = {
  name: 'LandingStatisticsHeader'
};/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.blockText
  }, [_c('div', {
    class: _vm.$style.blockTextMain
  }, [_vm._v("\n    United Finance DApp "), _c('br'), _vm._v(" allows you\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.blockTextSecondary
  }, [_vm._v("\n    to mint and redeem wuTON tokens through easy user-friendly process:\n  ")])]);
};
var __vue_staticRenderFns__$z = [];

/* style */
const __vue_inject_styles__$z = function (inject) {
  if (!inject) return;
  inject("data-v-6d7f39e8_0", {
    source: ".src-lib-components-TheLanding-Statistics-blockText-P_98{max-width:570px}.src-lib-components-TheLanding-Statistics-blockTextMain-14tC{max-width:570px;color:var(--color-light);font:var(--f-40-mlsh)}.src-lib-components-TheLanding-Statistics-blockTextSecondary-2TDT{max-width:615px;color:var(--color-active);font:var(--f-40i-mlsh)}@media only screen and (max-width:768px){.src-lib-components-TheLanding-Statistics-blockTextMain-14tC{font:var(--f-32-mlsh)}.src-lib-components-TheLanding-Statistics-blockTextSecondary-2TDT{font:var(--f-32i-mlsh)}}@media only screen and (max-width:480px){.src-lib-components-TheLanding-Statistics-blockTextMain-14tC{font:var(--f-24-mlsh)}.src-lib-components-TheLanding-Statistics-blockTextSecondary-2TDT{font:var(--f-24i-mlsh)}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "blockText": "src-lib-components-TheLanding-Statistics-blockText-P_98",
      "blockTextMain": "src-lib-components-TheLanding-Statistics-blockTextMain-14tC",
      "blockTextSecondary": "src-lib-components-TheLanding-Statistics-blockTextSecondary-2TDT"
    }
  });
};
/* scoped */
const __vue_scope_id__$z = undefined;
/* module identifier */
const __vue_module_identifier__$z = undefined;
/* functional template */
const __vue_is_functional_template__$z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, createInjector, undefined, undefined);
var LandingStatisticsHeader = __vue_component__$C;var script$y = {
  name: 'LandingStatisticsDescription',
  data() {
    return {
      items: ['Connect Wallet: Access your funds with your favorite TON wallet.', 'Mint wuTON: Convert TON from your wallet directly to wuTON and start earning yield automatically.', 'Redeem TON: Exchange your wuTON back for TON plus generated yield anytime you need']
    };
  }
};/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('ul', {
    class: _vm.$style.list
  }, _vm._l(_vm.items, function (item, index) {
    return _c('li', {
      key: index,
      class: _vm.$style.blockTextMain
    }, [_vm._v("\n    " + _vm._s(item) + "\n  ")]);
  }), 0);
};
var __vue_staticRenderFns__$y = [];

/* style */
const __vue_inject_styles__$y = function (inject) {
  if (!inject) return;
  inject("data-v-20008190_0", {
    source: ".src-lib-components-TheLanding-Statistics-list-2xr4{max-width:608px;color:var(--color-light);font:var(--f-18-mlsh)}.src-lib-components-TheLanding-Statistics-list-2xr4 li{margin-bottom:16px;list-style-type:disc;list-style-position:inside}@media only screen and (max-width:768px){.src-lib-components-TheLanding-Statistics-list-2xr4{font:var(--f-16-mlsh)}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "list": "src-lib-components-TheLanding-Statistics-list-2xr4"
    }
  });
};
/* scoped */
const __vue_scope_id__$y = undefined;
/* module identifier */
const __vue_module_identifier__$y = undefined;
/* functional template */
const __vue_is_functional_template__$y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, createInjector, undefined, undefined);
var LandingStatisticsDescription = __vue_component__$B;var script$x = {
  name: 'GeneralIndicatorBlock',
  props: {
    name: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    units: {
      type: String,
      default: ''
    },
    isComingSoon: {
      type: Boolean,
      default: false
    }
  }
};/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('div', {
    class: _vm.$style.name
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.description
  }, [_vm._v("\n    " + _vm._s(_vm.description) + "\n  ")]), _vm._v(" "), _vm.isComingSoon ? _c('div', {
    class: _vm.$style.textContainer
  }, [_c('span', {
    class: _vm.$style.text
  }, [_vm._v("\n      Coming soon\n    ")])]) : _c('div', {
    class: _vm.$style.valueContainer
  }, [_c('span', {
    class: _vm.$style.value
  }, [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")]), _vm._v(" "), _c('span', {
    class: _vm.$style.units
  }, [_vm._v("\n      " + _vm._s(_vm.units) + "\n    ")])])]);
};
var __vue_staticRenderFns__$x = [];

/* style */
const __vue_inject_styles__$x = function (inject) {
  if (!inject) return;
  inject("data-v-71b3771e_0", {
    source: ".src-lib-components-TheLanding-Statistics-GeneralIndicators-name-31ZF{color:var(--color-active);font:var(--f-b40-mlsh);text-transform:uppercase;letter-spacing:2px}.src-lib-components-TheLanding-Statistics-GeneralIndicators-description-1Csb{color:var(--color-active);font:var(--f-14-mlsh);font-weight:500;letter-spacing:.7px;opacity:.5}.src-lib-components-TheLanding-Statistics-GeneralIndicators-valueContainer-3wuh{white-space:nowrap}.src-lib-components-TheLanding-Statistics-GeneralIndicators-value-1QXm{color:var(--color-light);font:var(--f-48-mlsh);font-weight:500}.src-lib-components-TheLanding-Statistics-GeneralIndicators-units-1kJF{color:var(--color-light);font:var(--f-24-mlsh);font-weight:300;line-height:56px}.src-lib-components-TheLanding-Statistics-GeneralIndicators-textContainer-3yCu{margin-top:12px;white-space:nowrap}.src-lib-components-TheLanding-Statistics-GeneralIndicators-text-1cAZ{color:var(--color-light);opacity:.5;font:var(--f-48-mlsh)}@media only screen and (max-width:768px){.src-lib-components-TheLanding-Statistics-GeneralIndicators-name-31ZF{font:var(--f-b32-mlsh);line-height:48px;letter-spacing:1.6px}.src-lib-components-TheLanding-Statistics-GeneralIndicators-value-1QXm{font:var(--f-32-mlsh)}.src-lib-components-TheLanding-Statistics-GeneralIndicators-units-1kJF{line-height:40px}.src-lib-components-TheLanding-Statistics-GeneralIndicators-text-1cAZ{font:var(--f-32-mlsh)}}@media only screen and (max-width:390px){.src-lib-components-TheLanding-Statistics-GeneralIndicators-value-1QXm{font:var(--f-24-mlsh)}.src-lib-components-TheLanding-Statistics-GeneralIndicators-text-1cAZ{font:var(--f-24-mlsh)}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "name": "src-lib-components-TheLanding-Statistics-GeneralIndicators-name-31ZF",
      "description": "src-lib-components-TheLanding-Statistics-GeneralIndicators-description-1Csb",
      "valueContainer": "src-lib-components-TheLanding-Statistics-GeneralIndicators-valueContainer-3wuh",
      "value": "src-lib-components-TheLanding-Statistics-GeneralIndicators-value-1QXm",
      "units": "src-lib-components-TheLanding-Statistics-GeneralIndicators-units-1kJF",
      "textContainer": "src-lib-components-TheLanding-Statistics-GeneralIndicators-textContainer-3yCu",
      "text": "src-lib-components-TheLanding-Statistics-GeneralIndicators-text-1cAZ"
    }
  });
};
/* scoped */
const __vue_scope_id__$x = undefined;
/* module identifier */
const __vue_module_identifier__$x = undefined;
/* functional template */
const __vue_is_functional_template__$x = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, createInjector, undefined, undefined);
var GeneralIndicatorBlock = __vue_component__$A;var script$w = {
  name: 'LandingStatisticsGeneralIndicators',
  components: {
    GeneralIndicatorBlock
  },
  props: {
    tvl: {
      type: Number,
      default: 0
    },
    apy: {
      type: Number,
      default: 0
    }
  },
  methods: {
    formatNumber(value) {
      const maxThreshold = 10 ** 8;
      const options = {
        fractionDigits: 2,
        hideZeroFraction: true,
        gSep: ',',
        dSep: '.'
      };
      if (value >= maxThreshold) {
        return `>${format.number(maxThreshold, options)}`;
      }
      return format.number(value, options);
    }
  }
};/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('GeneralIndicatorBlock', {
    attrs: {
      "name": "TVL",
      "description": "Total value locked",
      "value": _vm.formatNumber(_vm.tvl),
      "units": "USDT",
      "is-coming-soon": true
    }
  }), _vm._v(" "), _c('hr', {
    class: _vm.$style.line
  }), _vm._v(" "), _c('GeneralIndicatorBlock', {
    attrs: {
      "name": "APY",
      "description": "Annual percentage yield",
      "value": _vm.formatNumber(_vm.apy * 100),
      "units": "%",
      "is-coming-soon": true
    }
  })], 1);
};
var __vue_staticRenderFns__$w = [];

/* style */
const __vue_inject_styles__$w = function (inject) {
  if (!inject) return;
  inject("data-v-02df6512_0", {
    source: ".src-lib-components-TheLanding-Statistics-block-3qgp{width:100%;min-width:515px;padding:120px 60px 124px 60px;background-color:var(--background-color-third);border-radius:var(--br-medium);box-sizing:border-box;flex-direction:column;justify-content:space-around;overflow:hidden}.src-lib-components-TheLanding-Statistics-line-Ujr5{margin:48px 0;width:100%;border-top:1px solid var(--line-color-secondary);opacity:.2}@media only screen and (max-width:768px){.src-lib-components-TheLanding-Statistics-block-3qgp{padding:32px 24px;width:100%;min-width:345px;max-width:80%}.src-lib-components-TheLanding-Statistics-line-Ujr5{margin:32px 0}}@media only screen and (max-width:390px){.src-lib-components-TheLanding-Statistics-block-3qgp{width:100%;min-width:245px;max-width:100%}.src-lib-components-TheLanding-Statistics-line-Ujr5{margin:24px 0}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-Statistics-block-3qgp",
      "line": "src-lib-components-TheLanding-Statistics-line-Ujr5"
    }
  });
};
/* scoped */
const __vue_scope_id__$w = undefined;
/* module identifier */
const __vue_module_identifier__$w = undefined;
/* functional template */
const __vue_is_functional_template__$w = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, createInjector, undefined, undefined);
var LandingStatisticsGeneralIndicators = __vue_component__$z;var script$v = {
  name: 'LandingStatisticsBlock',
  components: {
    ButtonUniversal,
    LandingStatisticsHeader,
    LandingStatisticsGeneralIndicators,
    LandingStatisticsDescription
  },
  data() {
    return {
      tvl: 0,
      apy: 0,
      isComingSoon: true
    };
  },
  computed: {
    statisticsSrvc() {
      return statisticsService();
    }
  },
  async created() {
    if (!this.isComingSoon) {
      await this.initialize();
    }
  },
  methods: {
    goToDApp() {
      window.open(this.$config.dappPageUri, '_self');
    },
    async initialize() {
      const {
        succeeded: succeeded1,
        tvl
      } = await this.statisticsSrvc.getTvlUsdt();
      const {
        succeeded: succeeded2,
        apy
      } = await this.statisticsSrvc.getApyUUsd({
        intervalInDays: 7
      });
      if (succeeded1) {
        this.tvl = tvl;
      }
      if (succeeded2) {
        this.apy = apy;
      }
    }
  }
};/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('section', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('LandingStatisticsHeader'), _vm._v(" "), _c('LandingStatisticsDescription', {
    class: _vm.$style.description
  }), _vm._v(" "), _c('LandingStatisticsGeneralIndicators', {
    class: _vm.$style.indicatorsMobile,
    attrs: {
      "tvl": _vm.tvl,
      "apy": _vm.apy
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.buttons
  }, [_vm.isComingSoon ? _c('ButtonUniversal', {
    class: _vm.$style.goToDAppButton,
    attrs: {
      "color": "stub"
    }
  }, [_vm._v("\n        Coming soon\n      ")]) : _c('ButtonUniversal', {
    class: _vm.$style.goToDAppButton,
    attrs: {
      "color": "enter"
    },
    on: {
      "click": _vm.goToDApp
    }
  }, [_vm._v("\n        Go to DApp\n      ")])], 1)], 1), _vm._v(" "), _c('LandingStatisticsGeneralIndicators', {
    class: _vm.$style.indicatorsDesktop,
    attrs: {
      "tvl": _vm.tvl,
      "apy": _vm.apy
    }
  })], 1);
};
var __vue_staticRenderFns__$v = [];

/* style */
const __vue_inject_styles__$v = function (inject) {
  if (!inject) return;
  inject("data-v-ab8a4d10_0", {
    source: ".src-lib-components-TheLanding-block-1BhE{margin:auto;max-width:1920px;min-height:807px;display:flex;justify-content:space-between;grid-column-gap:142px;-moz-column-gap:142px;column-gap:142px;background-color:var(--menu-background-color-secondary);border-radius:72px 72px 0 0;box-shadow:none!important}.src-lib-components-TheLanding-description-2pfX{margin-top:40px}.src-lib-components-TheLanding-indicatorsDesktop-3-Qm{max-width:515px;display:flex}.src-lib-components-TheLanding-indicatorsMobile-1NHL{display:none}.src-lib-components-TheLanding-buttons-3Zej{margin-top:48px;display:flex;justify-content:start}.src-lib-components-TheLanding-goToDAppButton-2lEg{box-sizing:border-box;height:40px;padding:12px 48px;display:flex;align-items:center;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px;min-height:48px}@media only screen and (min-width:1920px){.src-lib-components-TheLanding-block-1BhE{padding:96px 320px 99px 320px}}@media only screen and (min-width:769px) and (max-width:1919px){.src-lib-components-TheLanding-block-1BhE{padding:96px 72px 99px 72px}}@media only screen and (max-width:1280px){.src-lib-components-TheLanding-block-1BhE{flex-direction:column}.src-lib-components-TheLanding-content-2g3T{margin:auto}.src-lib-components-TheLanding-indicatorsDesktop-3-Qm{display:none!important}.src-lib-components-TheLanding-indicatorsMobile-1NHL{margin:auto;margin-top:40px;display:flex}.src-lib-components-TheLanding-buttons-3Zej{margin-top:40px;justify-content:center}}@media only screen and (max-width:768px){.src-lib-components-TheLanding-block-1BhE{min-height:448px;padding:48px 32px 80px 32px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheLanding-block-1BhE",
      "description": "src-lib-components-TheLanding-description-2pfX",
      "indicatorsDesktop": "src-lib-components-TheLanding-indicatorsDesktop-3-Qm",
      "indicatorsMobile": "src-lib-components-TheLanding-indicatorsMobile-1NHL",
      "buttons": "src-lib-components-TheLanding-buttons-3Zej",
      "goToDAppButton": "src-lib-components-TheLanding-goToDAppButton-2lEg",
      "content": "src-lib-components-TheLanding-content-2g3T"
    }
  });
};
/* scoped */
const __vue_scope_id__$v = undefined;
/* module identifier */
const __vue_module_identifier__$v = undefined;
/* functional template */
const __vue_is_functional_template__$v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, createInjector, undefined, undefined);
var LandingStatisticsBlock = __vue_component__$y;var script$u = {
  name: 'TheFooterMenu'
};/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('ul', {
    class: _vm.$style.menu
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.$config.docsPageUri
    }
  }, [_vm._v("\n      Documentation\n    ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.$config.termsOfServicePageUri
    }
  }, [_vm._v("\n      Terms of Service\n    ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.$config.privacyPolicyPageUri
    }
  }, [_vm._v("\n      Privacy Policy\n    ")])])]);
};
var __vue_staticRenderFns__$u = [];

/* style */
const __vue_inject_styles__$u = function (inject) {
  if (!inject) return;
  inject("data-v-159c2651_0", {
    source: ".src-lib-components-TheLayout-menu-jeUC{display:flex;grid-column-gap:48px;-moz-column-gap:48px;column-gap:48px;flex-wrap:wrap;grid-row-gap:16px;row-gap:16px}.src-lib-components-TheLayout-menu-jeUC a{display:flex;grid-column-gap:48px;-moz-column-gap:48px;column-gap:48px;color:var(--color-light);font:var(--f-14-mlsh);opacity:.5;-webkit-text-decoration-line:underline;text-decoration-line:underline;white-space:nowrap}@media (max-width:768px){.src-lib-components-TheLayout-menu-jeUC{justify-content:center}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "menu": "src-lib-components-TheLayout-menu-jeUC"
    }
  });
};
/* scoped */
const __vue_scope_id__$u = undefined;
/* module identifier */
const __vue_module_identifier__$u = undefined;
/* functional template */
const __vue_is_functional_template__$u = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, createInjector, undefined, undefined);
var TheFooterMenu = __vue_component__$x;var script$t = {
  name: 'TheFooter',
  components: {
    IconSvg,
    TheFooterMenu
  },
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('footer', {
    class: _vm.$style.footer
  }, [_c('div', {
    class: _vm.$style.subFooter
  }, [_c('div', {
    class: _vm.$style.left
  }, [_c('a', {
    class: _vm.$style.logoContainer,
    attrs: {
      "href": _vm.$config.landingPageUri
    }
  }, [_c('IconSvg', {
    class: _vm.$style.logo,
    attrs: {
      "png": "uf-logo"
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.logoName
  }, [_vm._v("\n          United Finance\n        ")])], 1), _vm._v(" "), _c('TheFooterMenu')], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.rightPane
  }, [_c('div', {
    class: _vm.$style.social
  }, [_c('a', {
    attrs: {
      "href": _vm.$config.telegramPageUri,
      "target": "_blank"
    }
  }, [_c('IconSvg', {
    class: _vm.$style.telegram,
    attrs: {
      "png": "telegram"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$config.githubPageUri,
      "target": "_blank"
    }
  }, [_c('IconSvg', {
    class: _vm.$style.github,
    attrs: {
      "png": "github"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: _vm.$style.copyrights
  }, [_vm._v("\n        ©️ " + _vm._s(_vm.currentYear) + "\n        "), _c('span', {
    class: _vm.$style.companyName
  }, [_vm._v("\n          United Finance\n        ")])])])])]);
};
var __vue_staticRenderFns__$t = [];

/* style */
const __vue_inject_styles__$t = function (inject) {
  if (!inject) return;
  inject("data-v-0e13718e_0", {
    source: ".src-lib-components-TheLayout-footer-23-z{box-sizing:border-box;background-color:var(--menu-background-color-secondary)}.src-lib-components-TheLayout-subFooter-1UHd{padding:24px 16px;height:-moz-fit-content;height:fit-content;display:flex;justify-content:space-between;align-items:center;grid-column-gap:69px;-moz-column-gap:69px;column-gap:69px;border-top:1px solid var(--line-color-primary)}.src-lib-components-TheLayout-left-103p{display:flex;align-items:center;grid-column-gap:69px;-moz-column-gap:69px;column-gap:69px}.src-lib-components-TheLayout-logo-1vGx{font-size:50px}.src-lib-components-TheLayout-logo-1vGx path{fill:var(--color-light);opacity:.5}.src-lib-components-TheLayout-logo-1vGx rect{stroke:var(--color-light);opacity:.5}.src-lib-components-TheLayout-logoContainer-246k{display:flex;align-items:center;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}.src-lib-components-TheLayout-logoName-3zH9{max-width:73px;min-width:40px;color:var(--color-light);font:var(--f-20-mlsh);line-height:20px;opacity:.5}.src-lib-components-TheLayout-rightPane-WI67{display:flex;align-items:center;grid-column-gap:25px;-moz-column-gap:25px;column-gap:25px}.src-lib-components-TheLayout-social-3WrU{display:flex;align-items:center;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}.src-lib-components-TheLayout-github-2YYb,.src-lib-components-TheLayout-telegram-B3Sv{font-size:24px}.src-lib-components-TheLayout-copyrights--KMe{color:var(--color-light);opacity:.5}.src-lib-components-TheLayout-companyName-1yed{white-space:nowrap}@media (max-width:768px){.src-lib-components-TheLayout-left-103p{flex-direction:column;grid-row-gap:32px;row-gap:32px}.src-lib-components-TheLayout-subFooter-1UHd{flex-direction:column;grid-row-gap:64px;row-gap:64px}.src-lib-components-TheLayout-rightPane-WI67{flex-direction:column;grid-row-gap:24px;row-gap:24px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "footer": "src-lib-components-TheLayout-footer-23-z",
      "subFooter": "src-lib-components-TheLayout-subFooter-1UHd",
      "left": "src-lib-components-TheLayout-left-103p",
      "logo": "src-lib-components-TheLayout-logo-1vGx",
      "logoContainer": "src-lib-components-TheLayout-logoContainer-246k",
      "logoName": "src-lib-components-TheLayout-logoName-3zH9",
      "rightPane": "src-lib-components-TheLayout-rightPane-WI67",
      "social": "src-lib-components-TheLayout-social-3WrU",
      "telegram": "src-lib-components-TheLayout-telegram-B3Sv",
      "github": "src-lib-components-TheLayout-github-2YYb",
      "copyrights": "src-lib-components-TheLayout-copyrights--KMe",
      "companyName": "src-lib-components-TheLayout-companyName-1yed"
    }
  });
};
/* scoped */
const __vue_scope_id__$t = undefined;
/* module identifier */
const __vue_module_identifier__$t = undefined;
/* functional template */
const __vue_is_functional_template__$t = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, createInjector, undefined, undefined);
var TheFooter = __vue_component__$w;var script$s = {
  name: 'LandingFooter',
  components: {
    TheFooter
  }
};/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('TheFooter', {
    class: _vm.$style.footer
  });
};
var __vue_staticRenderFns__$s = [];

/* style */
const __vue_inject_styles__$s = function (inject) {
  if (!inject) return;
  inject("data-v-451141b4_0", {
    source: "@media only screen and (min-width:1920px){.src-lib-components-TheLanding-footer-2dGM{padding:0 320px}}@media only screen and (min-width:769px) and (max-width:1919px){.src-lib-components-TheLanding-footer-2dGM{padding:0 72px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "footer": "src-lib-components-TheLanding-footer-2dGM"
    }
  });
};
/* scoped */
const __vue_scope_id__$s = undefined;
/* module identifier */
const __vue_module_identifier__$s = undefined;
/* functional template */
const __vue_is_functional_template__$s = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, createInjector, undefined, undefined);
var LandingFooter = __vue_component__$v;var script$r = {
  name: 'TheLanding',
  components: {
    TheLayout,
    LandingHeader,
    LandingMainBlock,
    LandingProtocolDescription,
    LandingProtocolFeatures,
    LandingStatisticsBlock,
    LandingFooter
  },
  data() {
    return {
      layoutColor: styleEnums.layoutColors.secondary
    };
  }
};/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('TheLayout', {
    attrs: {
      "background-color": _vm.layoutColor
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('LandingHeader')];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('LandingMainBlock'), _vm._v(" "), _c('LandingProtocolDescription'), _vm._v(" "), _c('LandingProtocolFeatures', {
          class: _vm.$style.features
        }), _vm._v(" "), _c('LandingStatisticsBlock', {
          class: _vm.$style.statistics
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('LandingFooter')];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$r = [];

/* style */
const __vue_inject_styles__$r = function (inject) {
  if (!inject) return;
  inject("data-v-2ceb09d0_0", {
    source: "body{background-color:var(--background-color-secondary)}main{position:relative}.src-lib-components-features-2L4a{margin-top:96px!important}.src-lib-components-statistics-26x0{margin-top:94px!important}footer{position:relative}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "features": "src-lib-components-features-2L4a",
      "statistics": "src-lib-components-statistics-26x0"
    }
  });
};
/* scoped */
const __vue_scope_id__$r = undefined;
/* module identifier */
const __vue_module_identifier__$r = undefined;
/* functional template */
const __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);
var __vue_component__$u = __vue_component__$t;var script$q = {
  name: 'StrategyProgressBlock',
  components: {
    ProgressBar
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    percents: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: ''
    }
  }
};/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('div', {
    class: _vm.$style.name
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.body
  }, [_c('span', {
    class: _vm.$style.percents
  }, [_vm._v("\n      " + _vm._s(_vm.percents.toFixed(2)) + "%\n    ")]), _vm._v(" "), _c('span', {
    class: _vm.$style.value
  }, [_vm._v("\n      " + _vm._s(_vm.value) + " " + _vm._s(_vm.unit) + "\n    ")])]), _vm._v(" "), _c('ProgressBar', {
    attrs: {
      "percents": _vm.percents
    }
  })], 1);
};
var __vue_staticRenderFns__$q = [];

/* style */
const __vue_inject_styles__$q = function (inject) {
  if (!inject) return;
  inject("data-v-6b325986_0", {
    source: ".src-lib-components-TheAnalytics-StrategiesStatistics-name-2PxI{width:-moz-fit-content;width:fit-content;color:var(--color-light);font:var(--f-24-mlsh);font-weight:500;white-space:nowrap}.src-lib-components-TheAnalytics-StrategiesStatistics-body-3-e3{width:-moz-fit-content;width:fit-content;margin:8px 0;white-space:nowrap}.src-lib-components-TheAnalytics-StrategiesStatistics-percents-YM0f{margin-right:8px;color:var(--color-active);font:var(--f-24-mlsh);font-weight:500}.src-lib-components-TheAnalytics-StrategiesStatistics-value-1ByR{color:var(--color-light);font:var(--f-16-mlsh);opacity:.5;white-space:nowrap}@media only screen and (max-width:400px){.src-lib-components-TheAnalytics-StrategiesStatistics-body-3-e3{white-space:unset}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "name": "src-lib-components-TheAnalytics-StrategiesStatistics-name-2PxI",
      "body": "src-lib-components-TheAnalytics-StrategiesStatistics-body-3-e3",
      "percents": "src-lib-components-TheAnalytics-StrategiesStatistics-percents-YM0f",
      "value": "src-lib-components-TheAnalytics-StrategiesStatistics-value-1ByR"
    }
  });
};
/* scoped */
const __vue_scope_id__$q = undefined;
/* module identifier */
const __vue_module_identifier__$q = undefined;
/* functional template */
const __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);
var StrategyProgressBlock = __vue_component__$s;var script$p = {
  name: 'StrategyList',
  props: {
    strategies: {
      type: Array,
      default() {
        return [];
      }
    },
    unit: {
      type: String,
      default: ''
    }
  },
  computed: {
    totalValue() {
      const values = this.strategies.map(strategy => strategy.value || 0);
      return values.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }
  },
  methods: {
    format(number) {
      return number.toFixed(6);
    },
    getCircleStyle(color) {
      return {
        '--labelBackgroundColor': `${color}`
      };
    }
  }
};/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('div', {
    class: _vm.$style.header
  }, [_c('div', {
    class: _vm.$style.left
  }, [_vm._v("\n      Strategy\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.right
  }, [_vm._v("\n      Net asset value\n      "), _c('span', {
    class: _vm.$style.unit
  }, [_vm._v("\n        [" + _vm._s(_vm.unit) + "]\n      ")])])]), _vm._v(" "), _vm._l(_vm.strategies, function (strategy, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.row
    }, [_c('div', {
      class: _vm.$style.labelContainer
    }, [_c('div', {
      class: _vm.$style.circle,
      style: _vm.getCircleStyle(strategy.color)
    }), _vm._v(" "), _c('div', {
      class: _vm.$style.label
    }, [_vm._v("\n        " + _vm._s(strategy.name) + "\n      ")])]), _vm._v(" "), _c('div', {
      class: _vm.$style.value
    }, [_vm._v("\n      " + _vm._s(_vm.format(strategy.value)) + "\n    ")])]);
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.row
  }, [_c('div', {
    class: _vm.$style.label
  }, [_vm._v("\n      Total\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.value
  }, [_vm._v("\n      " + _vm._s(_vm.format(_vm.totalValue)) + "\n    ")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.row
  }, [_c('div', {
    class: _vm.$style.label
  }, [_vm._v("\n      Total " + _vm._s(_vm.unit) + " + in circulation\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.value
  }, [_vm._v("\n      " + _vm._s(_vm.format(_vm.totalValue)) + "\n    ")])])], 2);
};
var __vue_staticRenderFns__$p = [];

/* style */
const __vue_inject_styles__$p = function (inject) {
  if (!inject) return;
  inject("data-v-fbf44014_0", {
    source: ".src-lib-components-TheAnalytics-StrategiesStatistics-header-39MT{display:flex;justify-content:space-between;grid-column-gap:15px;-moz-column-gap:15px;column-gap:15px;color:var(--color-light);font:var(--f-b16-mlsh);letter-spacing:.8px;text-transform:uppercase}.src-lib-components-TheAnalytics-StrategiesStatistics-label-xmOG,.src-lib-components-TheAnalytics-StrategiesStatistics-labelContainer-12YD,.src-lib-components-TheAnalytics-StrategiesStatistics-left-24PQ{min-width:120px}.src-lib-components-TheAnalytics-StrategiesStatistics-right-1Ub8{text-align:right}.src-lib-components-TheAnalytics-StrategiesStatistics-unit-3xCO{font-weight:400;opacity:.5}.src-lib-components-TheAnalytics-StrategiesStatistics-row-3I06{padding:16px 0;display:flex;justify-content:space-between;grid-column-gap:15px;-moz-column-gap:15px;column-gap:15px}.src-lib-components-TheAnalytics-StrategiesStatistics-row-3I06:not(:last-child){border-bottom:1px dashed rgba(80,81,90,.7)}.src-lib-components-TheAnalytics-StrategiesStatistics-labelContainer-12YD{display:flex;align-items:center;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}.src-lib-components-TheAnalytics-StrategiesStatistics-label-xmOG{color:var(--color-light-dim-third);font:var(--f-b16-mlsh)}.src-lib-components-TheAnalytics-StrategiesStatistics-value-1k-2{color:var(--color-light-dim);font:var(--f-b16-mlsh)}.src-lib-components-TheAnalytics-StrategiesStatistics-circle-3fTO{background-color:var(--labelBackgroundColor);height:12px;width:12px;min-width:12px;min-height:12px;border-radius:50%}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-lib-components-TheAnalytics-StrategiesStatistics-header-39MT",
      "left": "src-lib-components-TheAnalytics-StrategiesStatistics-left-24PQ",
      "label": "src-lib-components-TheAnalytics-StrategiesStatistics-label-xmOG",
      "labelContainer": "src-lib-components-TheAnalytics-StrategiesStatistics-labelContainer-12YD",
      "right": "src-lib-components-TheAnalytics-StrategiesStatistics-right-1Ub8",
      "unit": "src-lib-components-TheAnalytics-StrategiesStatistics-unit-3xCO",
      "row": "src-lib-components-TheAnalytics-StrategiesStatistics-row-3I06",
      "value": "src-lib-components-TheAnalytics-StrategiesStatistics-value-1k-2",
      "circle": "src-lib-components-TheAnalytics-StrategiesStatistics-circle-3fTO"
    }
  });
};
/* scoped */
const __vue_scope_id__$p = undefined;
/* module identifier */
const __vue_module_identifier__$p = undefined;
/* functional template */
const __vue_is_functional_template__$p = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, createInjector, undefined, undefined);
var StrategyList = __vue_component__$r;var script$o = {
  name: 'StrategiesStatistics',
  components: {
    StrategyProgressBlock,
    StrategyList
  },
  props: {
    strategies: {
      type: Array,
      default() {
        return [];
      }
    },
    unit: {
      type: String,
      default: ''
    }
  },
  computed: {
    totalValue() {
      const values = this.strategies.map(strategy => strategy.value || 0);
      return values.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },
    fullStrategies() {
      if (!this.strategies || !types.isArray(this.strategies) || this.strategies.length === 0) {
        return [];
      }
      return this.strategies.map(strategy => ({
        ...strategy,
        percents: this.toRound((strategy.value || 0) / this.totalValue) * 100
      }));
    }
  },
  methods: {
    toRound(value) {
      return Math.round((value + Number.EPSILON) * 10000) / 10000;
    },
    getStrategyStyle(strategy) {
      return {
        '--maxProgressPercent': `${strategy.percents}%`
      };
    }
  }
};/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.header
  }, [_vm._v("\n    " + _vm._s(_vm.unit) + " portfolio\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.strategies
  }, _vm._l(_vm.fullStrategies, function (strategy, index) {
    return _c('StrategyProgressBlock', {
      key: index,
      class: _vm.$style.strategy,
      style: _vm.getStrategyStyle(strategy),
      attrs: {
        "name": strategy.name,
        "percents": strategy.percents,
        "value": strategy.value,
        "unit": _vm.unit
      }
    });
  }), 1), _vm._v(" "), _c('StrategyList', {
    attrs: {
      "strategies": _vm.fullStrategies,
      "unit": _vm.unit
    }
  })], 1);
};
var __vue_staticRenderFns__$o = [];

/* style */
const __vue_inject_styles__$o = function (inject) {
  if (!inject) return;
  inject("data-v-67adde87_0", {
    source: ".src-lib-components-TheAnalytics-block-irej{padding:48px;background:var(--ln-gr-dark);border-radius:var(--br-small);overflow:hidden}.src-lib-components-TheAnalytics-header-1qb1{color:var(--color-light-dim);font:var(--f-b32-mlsh)}.src-lib-components-TheAnalytics-strategies-3VR1{margin:56px 0;display:flex;flex-wrap:wrap;grid-row-gap:16px;row-gap:16px}.src-lib-components-TheAnalytics-strategy-2LqI{flex:1;width:var(--maxProgressPercent);min-width:260px;max-width:270px;padding:0 8px;overflow:hidden}@media only screen and (max-width:480px){.src-lib-components-TheAnalytics-block-irej{padding:24px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-block-irej",
      "header": "src-lib-components-TheAnalytics-header-1qb1",
      "strategies": "src-lib-components-TheAnalytics-strategies-3VR1",
      "strategy": "src-lib-components-TheAnalytics-strategy-2LqI"
    }
  });
};
/* scoped */
const __vue_scope_id__$o = undefined;
/* module identifier */
const __vue_module_identifier__$o = undefined;
/* functional template */
const __vue_is_functional_template__$o = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, createInjector, undefined, undefined);
var StrategiesStatistics = __vue_component__$q;var script$n = {
  name: 'TermButtons',
  props: {
    terms: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      activeTermId: this.getActiveTermId(this.terms)
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      const [term] = this.terms && this.terms.filter(x => x.id === this.activeTermId) || [];
      this.selectTerm(term);
    },
    selectTerm(term) {
      if (!term) {
        return;
      }
      this.activeTermId = term.id;
      this.$emit('select', term);
    },
    getActiveTermId(terms) {
      if (!terms || terms.length === 0) {
        return -1;
      }
      const activeTerm = terms[terms.length - 1];
      if (!activeTerm) {
        return -1;
      }
      return activeTerm.id;
    }
  }
};/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, _vm._l(_vm.terms, function (term, index) {
    var _obj;
    return _c('button', {
      key: index,
      class: [_vm.$style.button, (_obj = {}, _obj[_vm.$style.active] = _vm.activeTermId === term.id, _obj)],
      on: {
        "click": function ($event) {
          return _vm.selectTerm(term);
        }
      }
    }, [_vm._v("\n    " + _vm._s(term.caption) + "\n  ")]);
  }), 0);
};
var __vue_staticRenderFns__$n = [];

/* style */
const __vue_inject_styles__$n = function (inject) {
  if (!inject) return;
  inject("data-v-10d5812b_0", {
    source: ".src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-block-UDZI{width:-moz-fit-content;width:fit-content;display:flex;border-radius:var(--br-nano);overflow:hidden}.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-button-1ZsS{padding:12px;color:var(--button-font-color-standard);font:var(--f-12-mlsh);font-weight:500;border-style:none;box-shadow:none;background-color:var(--button-background-color-dark);cursor:pointer;text-transform:uppercase}.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-active-16kq{color:var(--button-font-color-enter);background-color:var(--button-background-color-enter);font-weight:800}@media only screen and (max-width:360px){.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-button-1ZsS{font:var(--f-11-mlsh)}.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-active-16kq{font-weight:800}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-block-UDZI",
      "button": "src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-button-1ZsS",
      "active": "src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-active-16kq"
    }
  });
};
/* scoped */
const __vue_scope_id__$n = undefined;
/* module identifier */
const __vue_module_identifier__$n = undefined;
/* functional template */
const __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);
var TermButtons = __vue_component__$p;var script$m = {
  name: 'ModeSingleSelectField',
  components: {
    SingleSelectField
  },
  props: {
    modes: {
      type: Array,
      default() {
        return [];
      }
    },
    mode: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SingleSelectField', {
    class: _vm.$style.block,
    attrs: {
      "options": _vm.modes,
      "value": _vm.mode
    },
    on: {
      "input": function (option) {
        return _vm.$emit('select', option);
      }
    },
    scopedSlots: _vm._u([{
      key: "selected",
      fn: function (ref) {
        var selected = ref.selected;
        return [selected ? _c('div', {
          class: _vm.$style.label
        }, [_vm._v("\n      " + _vm._s(selected.caption) + "\n    ")]) : _vm._e()];
      }
    }, {
      key: "option",
      fn: function (ref) {
        var option = ref.option;
        return [_c('div', {
          class: _vm.$style.option
        }, [_vm._v("\n      " + _vm._s(option.caption) + "\n    ")])];
      }
    }])
  });
};
var __vue_staticRenderFns__$m = [];

/* style */
const __vue_inject_styles__$m = function (inject) {
  if (!inject) return;
  inject("data-v-63c9f861_0", {
    source: ".src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-label-pIUt{width:-moz-fit-content;width:fit-content;min-width:130px;display:flex;align-items:center;justify-content:space-between;padding:12px 15px 12px 20px;background-color:var(--background-color-black);color:var(--color-light);font:var(--f-12-mlsh);font-weight:500;border-radius:var(--br-micro)}@media only screen and (min-width:481px){.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-block-1Z5Y>div:nth-child(2){background-color:var(--background-color-black);white-space:nowrap;border-radius:var(--br-micro)}.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-block-1Z5Y>div:nth-child(2) div>div{padding:0!important}.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-block-1Z5Y>div:nth-child(2) div>div:hover{background-color:transparent!important;opacity:.7}.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-block-1Z5Y>div:nth-child(2) div.src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-option-2P-U{min-width:130px;padding:12px 44px 12px 20px!important;color:var(--color-light);font:var(--f-12-mlsh);font-weight:500}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "label": "src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-label-pIUt",
      "block": "src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-block-1Z5Y",
      "option": "src-lib-components-TheAnalytics-LinearChart-ChartSettingsBlock-option-2P-U"
    }
  });
};
/* scoped */
const __vue_scope_id__$m = undefined;
/* module identifier */
const __vue_module_identifier__$m = undefined;
/* functional template */
const __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);
var ModeSingleSelectField = __vue_component__$o;var script$l = {
  name: 'ChartSettingsBlock',
  components: {
    TermButtons,
    ModeSingleSelectField
  },
  props: {
    terms: {
      type: Array,
      default() {
        return [];
      }
    },
    modes: {
      type: Array,
      default() {
        return [];
      }
    },
    mode: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  methods: {
    selectTerm(term) {
      this.$emit('selectTerm', term);
    },
    selectMode(mode) {
      this.$emit('selectMode', mode);
    }
  }
};/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('TermButtons', {
    attrs: {
      "terms": _vm.terms
    },
    on: {
      "select": _vm.selectTerm
    }
  }), _vm._v(" "), _c('ModeSingleSelectField', {
    class: _vm.$style.mode,
    attrs: {
      "modes": _vm.modes,
      "mode": _vm.mode
    },
    on: {
      "select": _vm.selectMode
    }
  })], 1);
};
var __vue_staticRenderFns__$l = [];

/* style */
const __vue_inject_styles__$l = function (inject) {
  if (!inject) return;
  inject("data-v-080b8593_0", {
    source: ".src-lib-components-TheAnalytics-LinearChart-block-2VYj{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;grid-row-gap:10px;row-gap:10px;grid-column-gap:10px;-moz-column-gap:10px;column-gap:10px}.src-lib-components-TheAnalytics-LinearChart-mode-2gJ9{width:-moz-fit-content!important;width:fit-content!important}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-LinearChart-block-2VYj",
      "mode": "src-lib-components-TheAnalytics-LinearChart-mode-2gJ9"
    }
  });
};
/* scoped */
const __vue_scope_id__$l = undefined;
/* module identifier */
const __vue_module_identifier__$l = undefined;
/* functional template */
const __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);
var ChartSettingsBlock = __vue_component__$n;var script$k = {
  name: 'ChartHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    comment: {
      type: String,
      default: ''
    }
  }
};/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.title
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.data
  }, [_c('div', {
    class: _vm.$style.value
  }, [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.comment
  }, [_vm._v("\n      " + _vm._s(_vm.comment) + "\n    ")])])]);
};
var __vue_staticRenderFns__$k = [];

/* style */
const __vue_inject_styles__$k = function (inject) {
  if (!inject) return;
  inject("data-v-c023b120_0", {
    source: ".src-lib-components-TheAnalytics-LinearChart-block-1jW9{display:flex;justify-content:space-between;align-items:flex-start;grid-column-gap:10px;-moz-column-gap:10px;column-gap:10px}.src-lib-components-TheAnalytics-LinearChart-title-2Opj{color:var(--color-light-dim);font:var(--f-b24-mlsh)}.src-lib-components-TheAnalytics-LinearChart-data-15tZ{display:flex;flex-direction:column;align-items:flex-end;grid-row-gap:6px;row-gap:6px}.src-lib-components-TheAnalytics-LinearChart-value-1Jdn{color:var(--color-active);font:var(--f-b24-mlsh)}.src-lib-components-TheAnalytics-LinearChart-comment-2ptt{text-align:right;color:var(--color-comment);font:var(--f-12-mlsh);font-weight:500}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-LinearChart-block-1jW9",
      "title": "src-lib-components-TheAnalytics-LinearChart-title-2Opj",
      "data": "src-lib-components-TheAnalytics-LinearChart-data-15tZ",
      "value": "src-lib-components-TheAnalytics-LinearChart-value-1Jdn",
      "comment": "src-lib-components-TheAnalytics-LinearChart-comment-2ptt"
    }
  });
};
/* scoped */
const __vue_scope_id__$k = undefined;
/* module identifier */
const __vue_module_identifier__$k = undefined;
/* functional template */
const __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);
var ChartHeader = __vue_component__$m;Chart.register(Title, Tooltip, Legend, Filler, LineElement, LinearScale, CategoryScale, PointElement, TimeScale);
const configurationDefault = {
  type: 'line',
  data: {
    datasets: []
  },
  options: {},
  plugins: []
};
var script$j = {
  name: 'LineChart',
  components: {
    LineChartGenerator: Line
  },
  props: {
    dataSet: {
      type: Array,
      default() {
        return [];
      }
    },
    xAxisName: {
      type: String,
      default: ''
    },
    yAxisName: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      chartOptions: configurationDefault.options,
      chartPlugins: configurationDefault.plugins
    };
  },
  computed: {
    chartData() {
      return {
        datasets: [{
          label: this.label,
          data: this.dataSet,
          fill: true,
          radius: 0,
          backgroundColor: context => {
            const bgColor = ['rgba(26, 217, 116, 0.7)', 'rgb(47, 47, 59, 0.2)'];
            if (!context.chart.chartArea) {
              return null;
            }
            const {
              ctx,
              data,
              chartArea: {
                top,
                bottom
              }
            } = context.chart;
            const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
            gradientBg.addColorStop(0, bgColor[0]);
            gradientBg.addColorStop(0.3, bgColor[0]);
            gradientBg.addColorStop(1, bgColor[1]);
            return gradientBg;
          },
          pointHoverBackgroundColor: '#242424',
          pointHoverBorderColor: '#fff',
          pointHoverBorderWidth: 2,
          pointStyle: 'circle',
          borderWidth: 1,
          borderColor: '#15FF81',
          pointBorderColor: '#15FF81',
          pointBackgroundColor: '#15FF81',
          pointRadius: 4
        }]
      };
    }
  },
  mounted() {
    this.loading = true;
    const options = this.setupOptions();
    const plugins = this.setupPlugins();
    this.chartOptions = options;
    this.chartPlugins = plugins;
    this.loading = false;
  },
  methods: {
    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    setupOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          easing: 'easeInOutQuad',
          duration: 520
        },
        interaction: {
          intersect: false,
          mode: 'index'
        },
        elements: {
          line: {
            tension: 0.4
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            usePointStyle: true,
            displayColors: false,
            backgroundColor: '#fff',
            titleMarginBottom: 4,
            titleAlign: 'center',
            titleColor: '#5A5A5A',
            titleFont: {
              size: 8,
              lineHeight: 2,
              weight: 500
            },
            bodyAlign: 'center',
            bodyColor: '#00A54C',
            bodyFont: {
              size: 12,
              lineHeight: 1.3,
              weight: 700
            },
            padding: {
              top: 12,
              right: 19,
              bottom: 18,
              left: 19
            }
          }
        },
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'day',
              tooltipFormat: 'dd.MM.yyyy HH:mm',
              displayFormats: {
                day: 'dd.MM.yyyy'
              }
            },
            title: {
              display: true,
              align: 'end',
              text: this.xAxisName,
              font: {
                size: 14,
                weight: 500
              },
              color: '#FFF',
              padding: 0
            },
            ticks: {
              source: 'auto',
              stepSize: 2
            },
            grid: {
              display: false
            },
            border: {
              color: '#6B6B6B',
              width: 1
            }
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              align: 'end',
              text: this.yAxisName,
              font: {
                size: 14,
                weight: 500
              },
              color: '#FFF',
              padding: 0
            },
            grid: {
              display: true,
              color: 'rgba(255, 255, 255, 0.3)',
              z: 1,
              tickWidth: 0
            },
            border: {
              color: '#6B6B6B',
              width: 1,
              dash: [1, 6]
            }
          }
        }
      };
    },
    setupPlugins() {
      return [];
    }
  }
};/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [!_vm.loading ? _c('LineChartGenerator', {
    attrs: {
      "data": _vm.chartData,
      "options": _vm.chartOptions,
      "plugins": _vm.chartPlugins,
      "dataset-id-key": "datasetIdKey"
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$j = [];

/* style */
const __vue_inject_styles__$j = function (inject) {
  if (!inject) return;
  inject("data-v-b86575dc_0", {
    source: "",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {}
  });
};
/* scoped */
const __vue_scope_id__$j = undefined;
/* module identifier */
const __vue_module_identifier__$j = undefined;
/* functional template */
const __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);
var LineChart = __vue_component__$l;const modes$1 = [{
  id: 1,
  caption: '7–Day MA'
}, {
  id: 2,
  caption: '30–Day MA'
}];
const terms$1 = [{
  id: 1,
  caption: '1W',
  value: '1W'
}, {
  id: 2,
  caption: '1M',
  value: '1M'
}, {
  id: 3,
  caption: '3M',
  value: '3M'
}, {
  id: 4,
  caption: '6M',
  value: '6M'
}, {
  id: 5,
  caption: '1Y',
  value: '1Y'
}, {
  id: 6,
  caption: 'All time',
  value: 'All time'
}];
var script$i = {
  name: 'ApyChart',
  components: {
    ChartSettingsBlock,
    ChartHeader,
    LineChart
  },
  data() {
    return {
      dataSet: [],
      terms: terms$1,
      modes: modes$1,
      mode: modes$1[0]
    };
  },
  methods: {
    selectTerm(term) {
      this.dataSet = this.getChartDataSet();
    },
    selectMode(mode) {
      this.mode = mode;
    },
    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    getChartDataSet() {
      const data = [];
      let date = new Date();
      for (let i = 0; i < 20; i += 1) {
        date = this.addDays(date, -1);
        data.push({
          x: date,
          y: 100 + Math.random() * 4
        });
      }
      return data;
    }
  }
};/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('ChartSettingsBlock', {
    attrs: {
      "terms": _vm.terms,
      "modes": _vm.modes,
      "mode": _vm.mode
    },
    on: {
      "selectTerm": _vm.selectTerm,
      "selectMode": _vm.selectMode
    }
  }), _vm._v(" "), _c('ChartHeader', {
    class: _vm.$style.header,
    attrs: {
      "title": "Average wuTON APY",
      "value": "5.90%",
      "comment": "from 10.03.2024"
    }
  }), _vm._v(" "), _c('LineChart', {
    class: _vm.$style.chart,
    attrs: {
      "data-set": _vm.dataSet,
      "label": "APY",
      "x-axis-name": "days",
      "y-axis-name": "%"
    }
  })], 1);
};
var __vue_staticRenderFns__$i = [];

/* style */
const __vue_inject_styles__$i = function (inject) {
  if (!inject) return;
  inject("data-v-6499a71e_0", {
    source: ".src-lib-components-TheAnalytics-block-2bMd{padding:48px;background:var(--ln-gr-dark);border-radius:var(--br-small);overflow:hidden}.src-lib-components-TheAnalytics-header-K-tZ{margin-top:24px}.src-lib-components-TheAnalytics-chart-2XGu{margin-top:16px;min-height:300px}@media only screen and (max-width:480px){.src-lib-components-TheAnalytics-block-2bMd{padding:24px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-block-2bMd",
      "header": "src-lib-components-TheAnalytics-header-K-tZ",
      "chart": "src-lib-components-TheAnalytics-chart-2XGu"
    }
  });
};
/* scoped */
const __vue_scope_id__$i = undefined;
/* module identifier */
const __vue_module_identifier__$i = undefined;
/* functional template */
const __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);
var ApyChart = __vue_component__$k;const modes = [{
  id: 1,
  caption: '7–Day MA'
}, {
  id: 2,
  caption: '30–Day MA'
}];
const terms = [{
  id: 1,
  caption: '1W',
  value: '1W'
}, {
  id: 2,
  caption: '1M',
  value: '1M'
}, {
  id: 3,
  caption: '3M',
  value: '3M'
}, {
  id: 4,
  caption: '6M',
  value: '6M'
}, {
  id: 5,
  caption: '1Y',
  value: '1Y'
}, {
  id: 6,
  caption: 'All time',
  value: 'All time'
}];
var script$h = {
  name: 'TvlChart',
  components: {
    ChartSettingsBlock,
    ChartHeader,
    LineChart
  },
  data() {
    return {
      dataSet: [],
      terms,
      modes,
      mode: modes[0]
    };
  },
  methods: {
    selectTerm(term) {
      this.dataSet = this.getChartDataSet();
    },
    selectMode(mode) {
      this.mode = mode;
    },
    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    getChartDataSet() {
      const data = [];
      let date = new Date();
      for (let i = 0; i < 20; i += 1) {
        date = this.addDays(date, -1);
        data.push({
          x: date,
          y: 60 + Math.random() * 4
        });
      }
      return data;
    }
  }
};/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('ChartSettingsBlock', {
    attrs: {
      "terms": _vm.terms,
      "modes": _vm.modes,
      "mode": _vm.mode
    },
    on: {
      "selectTerm": _vm.selectTerm,
      "selectMode": _vm.selectMode
    }
  }), _vm._v(" "), _c('ChartHeader', {
    class: _vm.$style.header,
    attrs: {
      "title": "wuTON TVL",
      "value": "86.239427 TON",
      "comment": "past 2 hours"
    }
  }), _vm._v(" "), _c('LineChart', {
    class: _vm.$style.chart,
    attrs: {
      "data-set": _vm.dataSet,
      "label": "TVL",
      "x-axis-name": "days",
      "y-axis-name": "TON"
    }
  })], 1);
};
var __vue_staticRenderFns__$h = [];

/* style */
const __vue_inject_styles__$h = function (inject) {
  if (!inject) return;
  inject("data-v-69e7334e_0", {
    source: ".src-lib-components-TheAnalytics-block-3V6m{padding:48px;background:var(--ln-gr-dark);border-radius:var(--br-small);overflow:hidden}.src-lib-components-TheAnalytics-header-3GDd{margin-top:24px}.src-lib-components-TheAnalytics-chart-3_MZ{margin-top:16px;min-height:300px}@media only screen and (max-width:480px){.src-lib-components-TheAnalytics-block-3V6m{padding:24px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-block-3V6m",
      "header": "src-lib-components-TheAnalytics-header-3GDd",
      "chart": "src-lib-components-TheAnalytics-chart-3_MZ"
    }
  });
};
/* scoped */
const __vue_scope_id__$h = undefined;
/* module identifier */
const __vue_module_identifier__$h = undefined;
/* functional template */
const __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);
var TvlChart = __vue_component__$j;var script$g = {
  name: 'JettonLogo',
  components: {
    IconSvg
  },
  props: {
    jettonName: {
      type: String,
      default: ''
    },
    tokenAddress: {
      type: String,
      default: ''
    },
    jettonImageId: {
      type: String,
      default: ''
    }
  }
};/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', [_c('IconSvg', {
    class: _vm.$style.icon,
    attrs: {
      "png": _vm.jettonImageId
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.name
  }, [_vm._v("\n      " + _vm._s(_vm.jettonName) + "\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.address
  }, [_vm._v("\n      " + _vm._s(_vm.tokenAddress) + "\n    ")])])]);
};
var __vue_staticRenderFns__$g = [];

/* style */
const __vue_inject_styles__$g = function (inject) {
  if (!inject) return;
  inject("data-v-3934f8dd_0", {
    source: ".src-lib-components-TheAnalytics-JettonStatistics-block-1mex{display:flex;grid-column-gap:16px;-moz-column-gap:16px;column-gap:16px;align-items:center}.src-lib-components-TheAnalytics-JettonStatistics-icon-8o5j{font-size:56px}.src-lib-components-TheAnalytics-JettonStatistics-container-1l1L{color:var(--color-light-dim-second)}.src-lib-components-TheAnalytics-JettonStatistics-name-37bI{font:var(--f-32-mlsh);font-weight:500}.src-lib-components-TheAnalytics-JettonStatistics-address-2SPk{margin-top:4px;font:var(--f-12-mlsh)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-JettonStatistics-block-1mex",
      "icon": "src-lib-components-TheAnalytics-JettonStatistics-icon-8o5j",
      "container": "src-lib-components-TheAnalytics-JettonStatistics-container-1l1L",
      "name": "src-lib-components-TheAnalytics-JettonStatistics-name-37bI",
      "address": "src-lib-components-TheAnalytics-JettonStatistics-address-2SPk"
    }
  });
};
/* scoped */
const __vue_scope_id__$g = undefined;
/* module identifier */
const __vue_module_identifier__$g = undefined;
/* functional template */
const __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);
var JettonLogo = __vue_component__$i;var script$f = {
  name: 'JettonDescription',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
};/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]);
};
var __vue_staticRenderFns__$f = [];

/* style */
const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-78c76f0c_0", {
    source: ".src-lib-components-TheAnalytics-JettonStatistics-block-39b7{display:flex;align-items:center;color:var(--color-light-dim-second);font:var(--f-12-mlsh)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-JettonStatistics-block-39b7"
    }
  });
};
/* scoped */
const __vue_scope_id__$f = undefined;
/* module identifier */
const __vue_module_identifier__$f = undefined;
/* functional template */
const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);
var JettonDescription = __vue_component__$h;var script$e = {
  name: 'JettonStatisticsParameter',
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
};/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('div', {
    class: _vm.$style.name
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.description
  }, [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")])]), _vm._v(" "), _c('div', {
    class: _vm.$style.value
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])]);
};
var __vue_staticRenderFns__$e = [];

/* style */
const __vue_inject_styles__$e = function (inject) {
  if (!inject) return;
  inject("data-v-02bb1692_0", {
    source: ".src-lib-components-TheAnalytics-JettonStatistics-block-2eOs{color:var(--color-light-dim-second)}.src-lib-components-TheAnalytics-JettonStatistics-header-vci6{display:flex;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}.src-lib-components-TheAnalytics-JettonStatistics-name-2HEr{font:var(--f-b16-mlsh)}.src-lib-components-TheAnalytics-JettonStatistics-description-3wYQ{font:var(--f-b16-mlsh);opacity:.4}.src-lib-components-TheAnalytics-JettonStatistics-value-3XUc{margin-top:16px;font:var(--f-32-mlsh);white-space:nowrap}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-JettonStatistics-block-2eOs",
      "header": "src-lib-components-TheAnalytics-JettonStatistics-header-vci6",
      "name": "src-lib-components-TheAnalytics-JettonStatistics-name-2HEr",
      "description": "src-lib-components-TheAnalytics-JettonStatistics-description-3wYQ",
      "value": "src-lib-components-TheAnalytics-JettonStatistics-value-3XUc"
    }
  });
};
/* scoped */
const __vue_scope_id__$e = undefined;
/* module identifier */
const __vue_module_identifier__$e = undefined;
/* functional template */
const __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);
var JettonStatisticsParameter = __vue_component__$g;var script$d = {
  name: 'JettonStatistics',
  components: {
    JettonLogo,
    JettonDescription,
    JettonStatisticsParameter
  },
  props: {
    jettonName: {
      type: String,
      default: ''
    },
    tokenAddress: {
      type: String,
      default: ''
    },
    jettonImageId: {
      type: String,
      default: ''
    },
    jettonDescription: {
      type: String,
      default: ''
    },
    apyName: {
      type: String,
      default: ''
    },
    apyValue: {
      type: String,
      default: ''
    },
    tvlName: {
      type: String,
      default: ''
    },
    tvlValue: {
      type: String,
      default: ''
    },
    tvlDescription: {
      type: String,
      default: ''
    }
  }
};/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.leftPane
  }, [_c('JettonLogo', {
    attrs: {
      "jetton-name": _vm.jettonName,
      "token-address": _vm.tokenAddress,
      "jetton-image-id": _vm.jettonImageId
    }
  }), _vm._v(" "), _c('JettonDescription', {
    class: _vm.$style.description,
    attrs: {
      "text": _vm.jettonDescription
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.rigthPane
  }, [_c('div', {
    class: _vm.$style.firstVerticalLine
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.firstHorizontalLine
  }), _vm._v(" "), _c('JettonStatisticsParameter', {
    class: _vm.$style.parameter,
    attrs: {
      "name": _vm.apyName,
      "value": _vm.apyValue
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.secondVerticalLine
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.secondHorizontalLine
  }), _vm._v(" "), _c('JettonStatisticsParameter', {
    class: _vm.$style.parameter,
    attrs: {
      "name": _vm.tvlName,
      "value": _vm.tvlValue,
      "description": _vm.tvlDescription
    }
  })], 1)]);
};
var __vue_staticRenderFns__$d = [];

/* style */
const __vue_inject_styles__$d = function (inject) {
  if (!inject) return;
  inject("data-v-cdf8e3c4_0", {
    source: ".src-lib-components-TheAnalytics-block-3_wN{display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;grid-row-gap:15px;row-gap:15px;grid-column-gap:20px;-moz-column-gap:20px;column-gap:20px}.src-lib-components-TheAnalytics-leftPane-3_5s{display:flex;flex-wrap:wrap;grid-row-gap:15px;row-gap:15px;grid-column-gap:40px;-moz-column-gap:40px;column-gap:40px}.src-lib-components-TheAnalytics-rigthPane-2l7L{display:flex}.src-lib-components-TheAnalytics-description-3QLY{max-width:390px}.src-lib-components-TheAnalytics-firstVerticalLine-1zIa,.src-lib-components-TheAnalytics-secondVerticalLine-2qsq{margin:0 32px;display:block;border-right:1px solid rgba(21,255,129,.3)}.src-lib-components-TheAnalytics-firstHorizontalLine-2Sgq,.src-lib-components-TheAnalytics-secondHorizontalLine-Zaw-{width:100%;margin:32px 8px;border-top:1px solid rgba(21,255,129,.3)}@media only screen and (max-width:1100px){.src-lib-components-TheAnalytics-block-3_wN{justify-content:center}.src-lib-components-TheAnalytics-leftPane-3_5s{justify-content:center}.src-lib-components-TheAnalytics-firstVerticalLine-1zIa{display:none}}@media only screen and (max-width:624px){.src-lib-components-TheAnalytics-description-3QLY{text-align:center}}@media only screen and (max-width:420px){.src-lib-components-TheAnalytics-block-3_wN{grid-row-gap:0;row-gap:0}.src-lib-components-TheAnalytics-rigthPane-2l7L{flex-direction:column;align-items:center}.src-lib-components-TheAnalytics-secondVerticalLine-2qsq{display:none}.src-lib-components-TheAnalytics-parameter-1ils div{display:flex;justify-content:center}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-block-3_wN",
      "leftPane": "src-lib-components-TheAnalytics-leftPane-3_5s",
      "rigthPane": "src-lib-components-TheAnalytics-rigthPane-2l7L",
      "description": "src-lib-components-TheAnalytics-description-3QLY",
      "firstVerticalLine": "src-lib-components-TheAnalytics-firstVerticalLine-1zIa",
      "secondVerticalLine": "src-lib-components-TheAnalytics-secondVerticalLine-2qsq",
      "firstHorizontalLine": "src-lib-components-TheAnalytics-firstHorizontalLine-2Sgq",
      "secondHorizontalLine": "src-lib-components-TheAnalytics-secondHorizontalLine-Zaw-",
      "parameter": "src-lib-components-TheAnalytics-parameter-1ils"
    }
  });
};
/* scoped */
const __vue_scope_id__$d = undefined;
/* module identifier */
const __vue_module_identifier__$d = undefined;
/* functional template */
const __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);
var JettonStatistics = __vue_component__$f;var script$c = {
  name: 'JettonList',
  components: {
    ProgressBar
  },
  props: {
    jettons: {
      type: Array,
      default() {
        return [];
      }
    },
    unit: {
      type: String,
      default: ''
    }
  },
  methods: {
    format(number) {
      return number.toFixed(2);
    }
  }
};/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.title
  }, [_vm._v("\n    " + _vm._s(_vm.unit) + " collateral\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.header
  }, [_c('div', [_vm._v("\n      Liquid stake coins\n    ")]), _vm._v(" "), _c('div', [_vm._v("\n      Quantity\n    ")])]), _vm._v(" "), _vm._l(_vm.jettons, function (jetton, index) {
    return _c('div', {
      key: index,
      class: _vm.$style.row
    }, [_c('div', {
      class: _vm.$style.labelContainer
    }, [_c('div', {
      class: _vm.$style.label
    }, [_vm._v("\n        " + _vm._s(jetton.name) + "\n      ")]), _vm._v(" "), _c('ProgressBar', {
      attrs: {
        "percents": jetton.percents
      }
    })], 1), _vm._v(" "), _c('div', {
      class: _vm.$style.value
    }, [_vm._v("\n      " + _vm._s(_vm.format(jetton.percents)) + "%\n    ")])]);
  })], 2);
};
var __vue_staticRenderFns__$c = [];

/* style */
const __vue_inject_styles__$c = function (inject) {
  if (!inject) return;
  inject("data-v-2cdc2eba_0", {
    source: ".src-lib-components-TheAnalytics-block-bNiI{padding:48px;background:var(--ln-gr-dark);border-radius:var(--br-small);overflow:hidden}.src-lib-components-TheAnalytics-title-192i{color:var(--color-light-dim);font:var(--f-b32-mlsh)}.src-lib-components-TheAnalytics-header-3JOg{margin:56px 0 8px 0;display:flex;justify-content:space-between;grid-column-gap:15px;-moz-column-gap:15px;column-gap:15px;color:var(--color-light);font:var(--f-b16-mlsh);letter-spacing:.8px;text-transform:uppercase}.src-lib-components-TheAnalytics-row-1-RO{padding:16px 0;display:flex;justify-content:space-between;grid-column-gap:15px;-moz-column-gap:15px;column-gap:15px}.src-lib-components-TheAnalytics-row-1-RO:not(:last-child){border-bottom:1px dashed rgba(80,81,90,.7)}.src-lib-components-TheAnalytics-labelContainer-3HKA{flex:8;display:flex;align-items:center;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px}.src-lib-components-TheAnalytics-label-3kZK{min-width:55px;color:var(--color-light-dim-third);font:var(--f-b16-mlsh)}.src-lib-components-TheAnalytics-value-3RAX{flex:2;text-align:right;color:var(--color-light-dim);font:var(--f-b16-mlsh)}@media only screen and (max-width:480px){.src-lib-components-TheAnalytics-block-bNiI{padding:24px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheAnalytics-block-bNiI",
      "title": "src-lib-components-TheAnalytics-title-192i",
      "header": "src-lib-components-TheAnalytics-header-3JOg",
      "row": "src-lib-components-TheAnalytics-row-1-RO",
      "labelContainer": "src-lib-components-TheAnalytics-labelContainer-3HKA",
      "label": "src-lib-components-TheAnalytics-label-3kZK",
      "value": "src-lib-components-TheAnalytics-value-3RAX"
    }
  });
};
/* scoped */
const __vue_scope_id__$c = undefined;
/* module identifier */
const __vue_module_identifier__$c = undefined;
/* functional template */
const __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);
var JettonList = __vue_component__$e;var script$b = {
  name: 'TheAnalytics',
  components: {
    TheLayout,
    LandingHeader,
    LandingFooter,
    StrategiesStatistics,
    ApyChart,
    TvlChart,
    JettonStatistics,
    JettonList
  },
  data() {
    return {
      layoutColor: styleEnums.layoutColors.third,
      strategies: [{
        id: 1,
        value: 86.239427,
        name: 'Strategy 1',
        color: '#CF17DF'
      }, {
        id: 2,
        value: 32.316483,
        name: 'Strategy 2',
        color: '#3A08FF'
      }, {
        id: 3,
        value: 33.316483,
        name: 'Strategy 3',
        color: '#3A08FF'
      }, {
        id: 4,
        value: 13.316483,
        name: 'Strategy 4',
        color: '#3A08FF'
      }, {
        id: 5,
        value: 13.316483,
        name: 'Strategy 5',
        color: '#3A08FF'
      }],
      jettons: [{
        id: 1,
        percents: 72.23,
        name: 'TON'
      }, {
        id: 2,
        percents: 12,
        name: 'hTON'
      }, {
        id: 3,
        percents: 10,
        name: 'stTON'
      }, {
        id: 4,
        percents: 6,
        name: 'tsTON'
      }]
    };
  }
};/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('TheLayout', {
    attrs: {
      "background-color": _vm.layoutColor
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('LandingHeader', {
          class: _vm.$style.header
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('JettonStatistics', {
          class: _vm.$style.statistics,
          attrs: {
            "jetton-name": "wuTON",
            "token-address": "Token address",
            "jetton-image-id": "wuton",
            "jetton-description": "wuTON is a non-rebase yield bearing token, which represents a user's share of the TON collateral pool. It aims to deliver higher returns compared to traditional liquid staking tokens.",
            "apy-name": "Daily APY",
            "apy-value": "4.22%",
            "tvl-name": "TVL",
            "tvl-value": "102.51 wTON",
            "tvl-description": "past 4 hours"
          }
        }), _vm._v(" "), _c('ApyChart', {
          class: _vm.$style.apyChart
        }), _vm._v(" "), _c('TvlChart', {
          class: _vm.$style.marginTop40
        }), _vm._v(" "), _c('StrategiesStatistics', {
          class: _vm.$style.marginTop40,
          attrs: {
            "strategies": _vm.strategies,
            "unit": "wuTON"
          }
        }), _vm._v(" "), _c('JettonList', {
          class: _vm.$style.jettonList,
          attrs: {
            "jettons": _vm.jettons,
            "unit": "wuTON"
          }
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('LandingFooter', {
          class: _vm.$style.footer
        })];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$b = [];

/* style */
const __vue_inject_styles__$b = function (inject) {
  if (!inject) return;
  inject("data-v-0b5e8004_0", {
    source: "body{background-color:var(--background-color-black)}main{margin:auto;margin-top:90px;max-width:1440px}.src-lib-components-header-3eXp{max-width:1920px}.src-lib-components-statistics-1uq4{margin:32px 0}.src-lib-components-apyChart-c51J{margin-top:16px}.src-lib-components-marginTop40-1jDq{margin-top:40px}.src-lib-components-jettonList-36qY{margin:40px 0 80px 0}.src-lib-components-footer-1XrP{background-color:var(--background-color-black)!important}@media only screen and (min-width:480px) and (max-width:1440px){main{margin-left:20px;margin-right:20px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-lib-components-header-3eXp",
      "statistics": "src-lib-components-statistics-1uq4",
      "apyChart": "src-lib-components-apyChart-c51J",
      "marginTop40": "src-lib-components-marginTop40-1jDq",
      "jettonList": "src-lib-components-jettonList-36qY",
      "footer": "src-lib-components-footer-1XrP"
    }
  });
};
/* scoped */
const __vue_scope_id__$b = undefined;
/* module identifier */
const __vue_module_identifier__$b = undefined;
/* functional template */
const __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);
var __vue_component__$d = __vue_component__$c;var script$a = {
  name: 'MintRedeemBlockHeader'
};/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('h2', {
    class: _vm.$style.header
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$a = [];

/* style */
const __vue_inject_styles__$a = function (inject) {
  if (!inject) return;
  inject("data-v-678c0282_0", {
    source: ".src-lib-components-TheDapp-MintRedeemBlock-header-3m6N{margin:0;padding:0;box-sizing:border-box}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-lib-components-TheDapp-MintRedeemBlock-header-3m6N"
    }
  });
};
/* scoped */
const __vue_scope_id__$a = undefined;
/* module identifier */
const __vue_module_identifier__$a = undefined;
/* functional template */
const __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);
var MintRedeemBlockHeader = __vue_component__$b;var script$9 = {
  name: 'JettonSelectOption',
  components: {
    IconSvg
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    caption: {
      type: String,
      default: ''
    },
    money: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  methods: {
    formatMoney(money) {
      const moneyString = money.toString() || '';
      const {
        length
      } = moneyString;
      const maxLength = 11;
      return length > maxLength ? `${moneyString.substring(0, maxLength)}...` : moneyString;
    }
  }
};/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_vm.icon ? _c('IconSvg', {
    class: _vm.$style.icon,
    attrs: {
      "png": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.$style.text
  }, [_vm._v("\n    " + _vm._s(_vm.caption) + "\n  ")]), _vm._v(" "), _c('span', [_vm._v("\n    " + _vm._s(_vm.formatMoney(_vm.money)) + "\n  ")])], 1);
};
var __vue_staticRenderFns__$9 = [];

/* style */
const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-0e185d6d_0", {
    source: ".src-lib-components-TheDapp-MintRedeemBlock-Main-block-25K-{display:flex;align-items:center;flex-wrap:wrap;grid-column-gap:8px;-moz-column-gap:8px;column-gap:8px;grid-row-gap:5px;row-gap:5px}.src-lib-components-TheDapp-MintRedeemBlock-Main-icon-zndR{font-size:25px}.src-lib-components-TheDapp-MintRedeemBlock-Main-text-1inN{font:var(--f-b16-mlsh)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheDapp-MintRedeemBlock-Main-block-25K-",
      "icon": "src-lib-components-TheDapp-MintRedeemBlock-Main-icon-zndR",
      "text": "src-lib-components-TheDapp-MintRedeemBlock-Main-text-1inN"
    }
  });
};
/* scoped */
const __vue_scope_id__$9 = undefined;
/* module identifier */
const __vue_module_identifier__$9 = undefined;
/* functional template */
const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);
var JettonSelectOption = __vue_component__$a;var script$8 = {
  name: 'JettonSingleSelectField',
  components: {
    SingleSelectField,
    BorderedLabel,
    JettonSelectOption
  },
  props: {
    jettons: {
      type: Array,
      default() {
        return [];
      }
    },
    jetton: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SingleSelectField', {
    attrs: {
      "options": _vm.jettons,
      "value": _vm.jetton
    },
    on: {
      "input": function (jet) {
        return _vm.$emit('select', jet);
      }
    },
    scopedSlots: _vm._u([{
      key: "selected",
      fn: function (ref) {
        var selected = ref.selected;
        return [selected ? _c('BorderedLabel', {
          class: _vm.$style.label
        }, [_c('JettonSelectOption', {
          attrs: {
            "icon": selected.icon,
            "caption": selected.caption,
            "money": selected.balance
          }
        })], 1) : _vm._e()];
      }
    }, {
      key: "option",
      fn: function (ref) {
        var option = ref.option;
        return [_c('JettonSelectOption', {
          attrs: {
            "icon": option.icon,
            "caption": option.caption,
            "money": option.balance
          }
        })];
      }
    }])
  });
};
var __vue_staticRenderFns__$8 = [];

/* style */
const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-6967af5b_0", {
    source: ".src-lib-components-TheDapp-MintRedeemBlock-Main-label-sr6_{width:-moz-fit-content;width:fit-content;justify-content:space-between}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "label": "src-lib-components-TheDapp-MintRedeemBlock-Main-label-sr6_"
    }
  });
};
/* scoped */
const __vue_scope_id__$8 = undefined;
/* module identifier */
const __vue_module_identifier__$8 = undefined;
/* functional template */
const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);
var JettonSingleSelectField = __vue_component__$9;var script$7 = {
  name: 'MintRedeemBlockMain',
  components: {
    MoneyField,
    IconSvg,
    JettonSingleSelectField
  },
  props: {
    jettonsFrom: {
      type: Array,
      default() {
        return [];
      }
    },
    jettonsTo: {
      type: Array,
      default() {
        return [];
      }
    },
    jettonNameFrom: {
      type: String,
      default() {
        return null;
      }
    },
    jettonNameTo: {
      type: String,
      default() {
        return null;
      }
    },
    jettonRate: {
      type: Number,
      default: 1
    },
    canShowSwitch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      balanceFrom: null,
      balanceTo: null
    };
  },
  computed: {
    jettonFrom() {
      const [jetton] = this.jettonsFrom.filter(item => item.name === this.jettonNameFrom);
      return jetton || {};
    },
    jettonTo() {
      const [jetton] = this.jettonsTo.filter(item => item.name === this.jettonNameTo);
      return jetton || {};
    }
  },
  methods: {
    updateBalanceFrom(value) {
      this.balanceFrom = value;
      this.$emit('resetError');
      this.updateBalanceTo();
    },
    updateBalanceTo() {
      this.$nextTick(() => {
        this.balanceTo = this.balanceFrom * this.jettonRate;
      });
    },
    selectJettonFrom(jetton) {
      this.$emit('updateJettonFrom', jetton);
      this.updateBalanceTo();
    },
    selectJettonTo(jetton) {
      this.$emit('updateJettonTo', jetton);
      this.updateBalanceTo();
    },
    swicthJettons() {
      this.$emit('updateJetton', {
        jettonFrom: this.jettonTo,
        jettonTo: this.jettonFrom
      });
      this.updateBalanceTo();
    },
    getBalance() {
      return this.balanceFrom || 0;
    }
  }
};/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('JettonSingleSelectField', {
    attrs: {
      "jettons": _vm.jettonsFrom,
      "jetton": _vm.jettonFrom
    },
    on: {
      "select": _vm.selectJettonFrom
    }
  }), _vm._v(" "), _c('MoneyField', {
    class: _vm.$style.field,
    attrs: {
      "value": _vm.balanceFrom,
      "immediate": true,
      "hide-zero-fraction": true,
      "placeholder": "0"
    },
    on: {
      "input": _vm.updateBalanceFrom
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.label
  }, [_c('JettonSingleSelectField', {
    attrs: {
      "jettons": _vm.jettonsTo,
      "jetton": _vm.jettonTo
    },
    on: {
      "select": _vm.selectJettonTo
    }
  }), _vm._v(" "), _vm.canShowSwitch ? _c('div', {
    class: _vm.$style.switchIconWrapper
  }, [_c('IconSvg', {
    class: _vm.$style.switchIcon,
    attrs: {
      "png": "switch",
      "tabindex": "0"
    },
    on: {
      "click": _vm.swicthJettons,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.swicthJettons.apply(null, arguments);
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('MoneyField', {
    class: _vm.$style.field,
    attrs: {
      "value": _vm.balanceTo,
      "immediate": true,
      "disabled": true,
      "placeholder": "0"
    }
  })], 1);
};
var __vue_staticRenderFns__$7 = [];

/* style */
const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-4d641e06_0", {
    source: ".src-lib-components-TheDapp-MintRedeemBlock-block-1pIt{box-sizing:border-box;width:100%}.src-lib-components-TheDapp-MintRedeemBlock-field-2UA6{margin-top:8px;min-height:68px}.src-lib-components-TheDapp-MintRedeemBlock-switchIcon-2n_7{font-size:40px;cursor:pointer}.src-lib-components-TheDapp-MintRedeemBlock-label-1hGi{margin-top:12px;display:flex;flex-direction:row;align-items:center;justify-content:space-between;grid-column-gap:20px;-moz-column-gap:20px;column-gap:20px}@media only screen and (max-width:380px){.src-lib-components-TheDapp-MintRedeemBlock-label-1hGi{flex-direction:column-reverse;align-items:flex-start;grid-row-gap:12px;row-gap:12px}.src-lib-components-TheDapp-MintRedeemBlock-switchIconWrapper-vZUW{width:100%;display:flex;justify-content:center}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheDapp-MintRedeemBlock-block-1pIt",
      "field": "src-lib-components-TheDapp-MintRedeemBlock-field-2UA6",
      "switchIcon": "src-lib-components-TheDapp-MintRedeemBlock-switchIcon-2n_7",
      "label": "src-lib-components-TheDapp-MintRedeemBlock-label-1hGi",
      "switchIconWrapper": "src-lib-components-TheDapp-MintRedeemBlock-switchIconWrapper-vZUW"
    }
  });
};
/* scoped */
const __vue_scope_id__$7 = undefined;
/* module identifier */
const __vue_module_identifier__$7 = undefined;
/* functional template */
const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);
var MintRedeemBlockMain = __vue_component__$8;var script$6 = {
  name: 'MintRedeemBlockInfo',
  props: {
    jettonNameFrom: {
      type: String,
      default() {
        return '';
      }
    },
    jettonNameTo: {
      type: String,
      default() {
        return '';
      }
    },
    jettonRate: {
      type: Number,
      default: 1
    },
    platformFee: {
      type: Number,
      default: null
    },
    blockchainFeeMin: {
      type: Number,
      default: null
    },
    blockchainFeeMax: {
      type: Number,
      default: null
    }
  }
};/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('div', {
    class: _vm.$style.info
  }, [_vm._v("\n    1 " + _vm._s(_vm.jettonNameFrom) + " = " + _vm._s(_vm.jettonRate) + " " + _vm._s(_vm.jettonNameTo) + "\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.info
  }, [_vm._v("\n    United Finance fee: " + _vm._s(_vm.platformFee) + "%\n  ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.info
  }, [_vm._v("\n    Blockchain fee: " + _vm._s(_vm.blockchainFeeMin) + "-" + _vm._s(_vm.blockchainFeeMax) + " TON\n  ")])]);
};
var __vue_staticRenderFns__$6 = [];

/* style */
const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-075c48de_0", {
    source: ".src-lib-components-TheDapp-MintRedeemBlock-Footer-block-3D3N{box-sizing:border-box}.src-lib-components-TheDapp-MintRedeemBlock-Footer-info-2FWs{color:var(--color-info);font:var(--f-14-mlsh)}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheDapp-MintRedeemBlock-Footer-block-3D3N",
      "info": "src-lib-components-TheDapp-MintRedeemBlock-Footer-info-2FWs"
    }
  });
};
/* scoped */
const __vue_scope_id__$6 = undefined;
/* module identifier */
const __vue_module_identifier__$6 = undefined;
/* functional template */
const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);
var MintRedeemBlockInfo = __vue_component__$7;var script$5 = {
  name: 'MintRedeemBlockButtons',
  components: {
    ButtonUniversal
  },
  props: {
    isWalletConnected: {
      type: Boolean,
      default: false
    }
  }
};/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_vm.isWalletConnected ? _c('ButtonUniversal', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('swap');
      }
    }
  }, [_vm._v("\n    Swap\n  ")]) : _c('ButtonUniversal', {
    on: {
      "click": function ($event) {
        return _vm.$emit('connect');
      }
    }
  }, [_vm._v("\n    Connect wallet\n  ")])], 1);
};
var __vue_staticRenderFns__$5 = [];

/* style */
const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-0f80cd58_0", {
    source: ".src-lib-components-TheDapp-MintRedeemBlock-Footer-block-2qF6 button{width:100%}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheDapp-MintRedeemBlock-Footer-block-2qF6"
    }
  });
};
/* scoped */
const __vue_scope_id__$5 = undefined;
/* module identifier */
const __vue_module_identifier__$5 = undefined;
/* functional template */
const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);
var MintRedeemBlockButtons = __vue_component__$6;var script$4 = {
  name: 'MintRedeemBlockFooter',
  components: {
    LoaderChain,
    MintRedeemBlockInfo,
    MintRedeemBlockButtons
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default() {
        return null;
      }
    },
    isWalletConnected: {
      type: Boolean,
      default: false
    },
    platformFeePercents: {
      type: Number,
      default: 0
    },
    blockchainFeeTonMin: {
      type: Number,
      default: 0
    },
    blockchainFeeTonMax: {
      type: Number,
      default: 0
    },
    jettonRate: {
      type: Number,
      default: 1
    },
    jettonsFrom: {
      type: Array,
      default() {
        return [];
      }
    },
    jettonsTo: {
      type: Array,
      default() {
        return [];
      }
    },
    jettonNameFrom: {
      type: String,
      default() {
        return null;
      }
    },
    jettonNameTo: {
      type: String,
      default() {
        return null;
      }
    },
    isFailed: {
      type: Boolean,
      default: false
    },
    canShowInfoBlock: {
      type: Boolean,
      default: false
    },
    canShowButtonsBlock: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    jettonFrom() {
      const [jetton] = this.jettonsFrom.filter(item => item.name === this.jettonNameFrom);
      return jetton || {};
    },
    jettonTo() {
      const [jetton] = this.jettonsTo.filter(item => item.name === this.jettonNameTo);
      return jetton || {};
    }
  }
};/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_vm.loading && _vm.isWalletConnected ? _c('div', {
    class: _vm.$style.loader
  }, [_c('LoaderChain')], 1) : _vm._e(), _vm._v(" "), _vm.canShowInfoBlock ? _c('MintRedeemBlockInfo', {
    class: _vm.$style.info,
    attrs: {
      "jetton-name-from": _vm.jettonFrom.caption,
      "jetton-name-to": _vm.jettonTo.caption,
      "jetton-rate": _vm.jettonRate,
      "platform-fee": _vm.platformFeePercents,
      "blockchain-fee-min": _vm.blockchainFeeTonMin,
      "blockchain-fee-max": _vm.blockchainFeeTonMax
    }
  }) : _vm._e(), _vm._v(" "), _vm.canShowButtonsBlock ? _c('MintRedeemBlockButtons', {
    class: _vm.$style.buttons,
    attrs: {
      "is-wallet-connected": _vm.isWalletConnected
    },
    on: {
      "swap": function ($event) {
        return _vm.$emit('swap');
      },
      "connect": function ($event) {
        return _vm.$emit('connect');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isFailed ? [_c('div', {
    class: _vm.$style.error
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")])] : _vm._e()], 2);
};
var __vue_staticRenderFns__$4 = [];

/* style */
const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-6f7850bc_0", {
    source: ".src-lib-components-TheDapp-MintRedeemBlock-block-QSJL{box-sizing:border-box;width:100%}.src-lib-components-TheDapp-MintRedeemBlock-info-3sPn{margin-top:24px}.src-lib-components-TheDapp-MintRedeemBlock-buttons-1Miv{margin-top:24px;display:flex;justify-content:center}.src-lib-components-TheDapp-MintRedeemBlock-error-29y6{margin-top:24px;display:flex;justify-content:center;align-items:center;color:var(--color-error);font:var(--f-12-mlsh)}.src-lib-components-TheDapp-MintRedeemBlock-loader-2Bc2{display:flex;justify-content:center;margin:10px 0}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheDapp-MintRedeemBlock-block-QSJL",
      "info": "src-lib-components-TheDapp-MintRedeemBlock-info-3sPn",
      "buttons": "src-lib-components-TheDapp-MintRedeemBlock-buttons-1Miv",
      "error": "src-lib-components-TheDapp-MintRedeemBlock-error-29y6",
      "loader": "src-lib-components-TheDapp-MintRedeemBlock-loader-2Bc2"
    }
  });
};
/* scoped */
const __vue_scope_id__$4 = undefined;
/* module identifier */
const __vue_module_identifier__$4 = undefined;
/* functional template */
const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);
var MintRedeemBlockFooter = __vue_component__$5;var script$3 = {
  name: 'MintRedeemBlock',
  components: {
    MintRedeemBlockHeader,
    MintRedeemBlockMain,
    MintRedeemBlockFooter
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default() {
        return null;
      }
    },
    isWalletConnected: {
      type: Boolean,
      default: false
    },
    platformFeePercents: {
      type: Number,
      default: 0
    },
    blockchainFeeTonMin: {
      type: Number,
      default: 0
    },
    blockchainFeeTonMax: {
      type: Number,
      default: 0
    },
    jettonRate: {
      type: Number,
      default: 1
    },
    jettonsFrom: {
      type: Array,
      default() {
        return [];
      }
    },
    jettonsTo: {
      type: Array,
      default() {
        return [];
      }
    },
    jettonNameFrom: {
      type: String,
      default() {
        return null;
      }
    },
    jettonNameTo: {
      type: String,
      default() {
        return null;
      }
    }
  },
  computed: {
    isFailed() {
      return !!this.errorMessage;
    },
    canShowInfoBlock() {
      return !this.loading && !this.isFailed && this.isWalletConnected;
    },
    canShowButtonsBlock() {
      return this.canShowInfoBlock || !this.isWalletConnected;
    },
    mainData() {
      return {
        jettonsFrom: this.jettonsFrom,
        jettonsTo: this.jettonsTo,
        jettonNameFrom: this.jettonNameFrom,
        jettonNameTo: this.jettonNameTo,
        jettonRate: this.jettonRate,
        canShowSwitch: this.canShowInfoBlock
      };
    },
    footerData() {
      return {
        loading: this.loading,
        errorMessage: this.errorMessage,
        isWalletConnected: this.isWalletConnected,
        jettonsFrom: this.jettonsFrom,
        jettonsTo: this.jettonsTo,
        jettonNameFrom: this.jettonNameFrom,
        jettonNameTo: this.jettonNameTo,
        jettonRate: this.jettonRate,
        platformFeePercents: this.platformFeePercents,
        blockchainFeeTonMin: this.blockchainFeeTonMin,
        blockchainFeeTonMax: this.blockchainFeeTonMax,
        isFailed: this.isFailed,
        canShowInfoBlock: this.canShowInfoBlock,
        canShowButtonsBlock: this.canShowButtonsBlock
      };
    }
  },
  methods: {
    swap() {
      const balance = this.$refs.main.getBalance();
      this.$emit('swap', {
        balance
      });
    }
  }
};/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.$style.block
  }, [_c('MintRedeemBlockHeader', {
    class: _vm.$style.header
  }), _vm._v(" "), _c('MintRedeemBlockMain', _vm._b({
    ref: "main",
    on: {
      "resetError": function ($event) {
        return _vm.$emit('resetError');
      },
      "updateJettonFrom": function (jetton) {
        return _vm.$emit('updateJettonFrom', jetton);
      },
      "updateJettonTo": function (jetton) {
        return _vm.$emit('updateJettonTo', jetton);
      },
      "updateJetton": function (ref) {
        var jettonFrom = ref.jettonFrom;
        var jettonTo = ref.jettonTo;
        return _vm.$emit('updateJetton', {
          jettonFrom: jettonFrom,
          jettonTo: jettonTo
        });
      }
    }
  }, 'MintRedeemBlockMain', _vm.mainData, false)), _vm._v(" "), _c('MintRedeemBlockFooter', _vm._b({
    on: {
      "swap": _vm.swap,
      "connect": function ($event) {
        return _vm.$emit('connect');
      }
    }
  }, 'MintRedeemBlockFooter', _vm.footerData, false))], 1);
};
var __vue_staticRenderFns__$3 = [];

/* style */
const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-bcde80fe_0", {
    source: ".src-lib-components-TheDapp-block-2O-z{padding:24px 32px;display:flex;flex-direction:column;align-items:center}.src-lib-components-TheDapp-header-2AFr{width:100%;height:81px;padding-bottom:32px!important}@media only screen and (max-width:480px){.src-lib-components-TheDapp-block-2O-z{padding:24px 16px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheDapp-block-2O-z",
      "header": "src-lib-components-TheDapp-header-2AFr"
    }
  });
};
/* scoped */
const __vue_scope_id__$3 = undefined;
/* module identifier */
const __vue_module_identifier__$3 = undefined;
/* functional template */
const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);
var MintRedeemBlock = __vue_component__$4;var script$2 = {
  name: 'ConnectionBlock',
  components: {
    RectangularBlock,
    MintRedeemBlock
  },
  data() {
    return {
      loading: true,
      errorMessage: null,
      jettonsFrom: [],
      jettonsTo: [],
      jettonNameFrom: jettonEnums.jettons.usdt,
      jettonNameTo: jettonEnums.jettons.wuusd,
      jettonConvertionPairs: [],
      jettonPoolItems: []
    };
  },
  computed: {
    ...mapGetters('tonConnect', ['isWalletConnected', 'walletAddress']),
    walletSrvc() {
      return walletService();
    },
    jettonsSrvc() {
      return jettonsService();
    },
    jettonsPoolSrvc() {
      return jettonsPoolService();
    },
    jettonPoolItem() {
      const [item] = this.jettonPoolItems.filter(i => i.from === this.jettonNameFrom && i.to === this.jettonNameTo);
      return item || null;
    },
    jettonRate() {
      return this.jettonPoolItem && this.jettonPoolItem.rate || 1;
    },
    platformFeePercents() {
      return this.jettonPoolItem && this.jettonPoolItem.platformFeePercents || 1;
    },
    blockchainFeeTonMin() {
      return this.jettonPoolItem && this.jettonPoolItem.blockchainFeeTonMin || 0;
    },
    blockchainFeeTonMax() {
      return this.jettonPoolItem && this.jettonPoolItem.blockchainFeeTonMax || 0;
    },
    mintRedeemData() {
      return {
        loading: this.loading,
        errorMessage: this.errorMessage,
        isWalletConnected: this.isWalletConnected,
        platformFeePercents: this.platformFeePercents,
        blockchainFeeTonMin: this.blockchainFeeTonMin,
        blockchainFeeTonMax: this.blockchainFeeTonMax,
        jettonRate: this.jettonRate,
        jettonsFrom: this.jettonsFrom,
        jettonsTo: this.jettonsTo,
        jettonNameFrom: this.jettonNameFrom,
        jettonNameTo: this.jettonNameTo
      };
    }
  },
  watch: {
    isWalletConnected: {
      async handler(newValue, oldValue) {
        await this.walletConnectionStateHandle(newValue, oldValue);
      },
      immediate: true
    },
    walletAddress: {
      async handler(newValue, oldValue) {
        await this.walletDisconnectionStateHandle(newValue, oldValue);
      },
      immediate: true
    }
  },
  created() {
    this.updateJettonDataInitial();
  },
  methods: {
    ...mapActions('tonConnect', ['openSelectWalletModal', 'disconnectWallet', 'prepareTransactionMessage', 'sendTransaction']),
    setLoading(value) {
      this.loading = value;
    },
    setErrorMessage(message) {
      this.errorMessage = message;
    },
    resetError() {
      this.setErrorMessage(null);
    },
    validate(_ref) {
      let {
        balance
      } = _ref;
      if (!balance || balance <= 0) {
        return {
          isValid: false,
          errorMessage: 'Balance must be more than zero'
        };
      }
      return {
        isValid: true
      };
    },
    updateJettonConvertionPairs(jettonConvertionPairs) {
      this.jettonConvertionPairs = jettonConvertionPairs;
      if (this.jettonConvertionPairs.length === 0) {
        this.jettonsFrom = [];
        this.jettonsTo = [];
        return;
      }
      const [selectedJettonFrom] = this.jettonConvertionPairs.filter(x => x.source.name === this.jettonNameFrom);
      this.jettonsFrom = this.jettonConvertionPairs.map(x => x.source);
      this.jettonsTo = selectedJettonFrom.target;
    },
    updateJettonPoolItems(jettonPoolItems) {
      this.jettonPoolItems = [...jettonPoolItems];
    },
    updateJettonsTo() {
      const [selectedJettonFrom] = this.jettonConvertionPairs.filter(x => x.source.name === this.jettonNameFrom);
      this.jettonsTo = selectedJettonFrom.target;
    },
    updateJettonFrom(jetton) {
      this.jettonNameFrom = jetton.name;
      this.updateJettonsTo();
      const [jettonTo] = this.jettonsTo.filter(j => j.name === this.jettonNameTo);
      this.jettonNameTo = jettonTo ? jettonTo.name : this.jettonsTo[0].name;
    },
    updateJettonTo(jetton) {
      this.jettonNameTo = jetton.name;
    },
    updateJetton(_ref2) {
      let {
        jettonFrom,
        jettonTo
      } = _ref2;
      this.resetError();
      this.updateJettonTo(jettonTo);
      this.updateJettonFrom(jettonFrom);
    },
    walletDisconnectedHandle() {
      this.jettonPoolItems = [];
    },
    getJettonConvertionPairs() {
      const jettonsData = this.jettonsSrvc.getJettonsData();
      return this.jettonsSrvc.getJettonObjectConvertionPairs(jettonsData);
    },
    getJettonConvertionPairsEnrich(jettonPoolItems) {
      const jettonsData = this.jettonsSrvc.getJettonsData();
      const enrichJettonsData = this.jettonsPoolSrvc.enrichJettonsData(jettonsData, jettonPoolItems);
      return this.jettonsSrvc.getJettonObjectConvertionPairs(enrichJettonsData);
    },
    setJettonConvertionPairsInitial() {
      this.updateJettonConvertionPairs(this.getJettonConvertionPairs());
    },
    setJettonConvertionPairsEnrich(jettonPoolItems) {
      this.updateJettonConvertionPairs(this.getJettonConvertionPairsEnrich(jettonPoolItems));
    },
    updateJettonDataInitial() {
      this.setJettonConvertionPairsInitial();
      this.updateJettonPoolItems([]);
    },
    updateJettonDataEnrich(jettonPoolItems) {
      this.setJettonConvertionPairsEnrich(jettonPoolItems);
      this.updateJettonPoolItems(jettonPoolItems);
    },
    async walletConnectionStateHandle(newValue, oldValue) {
      if (newValue && !oldValue) {
        // connect
        await this.fetchJettonPoolData();
      }
      if (!newValue && oldValue) {
        // disconnect
        this.walletDisconnectedHandle();
      }
    },
    async walletDisconnectionStateHandle(newValue, oldValue) {
      // changing testnet to mainnet and vice versa in a wallet
      if (newValue && oldValue) {
        // disconnect
        await this.disconnectWallet();
        this.walletDisconnectedHandle();
      }
    },
    async fetchJettonPoolData() {
      this.setLoading(true);
      const {
        succeeded,
        jettonPoolItems
      } = await this.walletSrvc.getJettonPool(this.walletAddress);
      this.updateJettonDataEnrich(jettonPoolItems);
      if (!succeeded) {
        this.setLoading(false);
        const errorMessage = 'Failed to retrieve data. Try to reload the current page.';
        this.setErrorMessage(errorMessage);
        return;
      }
      this.setLoading(false);
    },
    async prepareParameters(_ref3) {
      let {
        balanceInJettons
      } = _ref3;
      const {
        addressFrom,
        vaultAddress,
        decimalsFrom
      } = this.jettonPoolItem;
      const {
        jettonNameFrom,
        jettonNameTo,
        walletAddress
      } = this;
      const {
        succeeded,
        balance
      } = await this.jettonsSrvc.convertBalance({
        balanceInJettons,
        decimals: decimalsFrom,
        jettonName: jettonNameFrom
      });
      if (!succeeded) {
        return {
          succeeded: false,
          parameters: null
        };
      }
      const parameters = {
        jettons: {
          jettonNameFrom,
          jettonNameTo
        },
        data: {
          balance,
          jettonWalletAddress: addressFrom,
          vaultAddress,
          walletV4Address: walletAddress
        }
      };
      return {
        succeeded: true,
        parameters
      };
    },
    async swap(_ref4) {
      let {
        balance
      } = _ref4;
      this.resetError();
      const {
        isValid,
        errorMessage
      } = this.validate({
        balance
      });
      if (!isValid) {
        this.setErrorMessage(errorMessage);
        return;
      }
      const {
        succeeded: succeededParameters,
        parameters
      } = await this.prepareParameters({
        balanceInJettons: balance
      });
      if (!succeededParameters) {
        // this.setErrorMessage(errorMessage);

        return;
      }
      const message = await this.prepareTransactionMessage(parameters);
      const {
        succeeded: succeededTransaction,
        result
      } = await this.sendTransaction({
        messages: [message]
      });
      if (succeededTransaction) {
        await this.fetchJettonPoolData();
      }
    }
  }
};/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('RectangularBlock', [_c('MintRedeemBlock', _vm._b({
    on: {
      "connect": _vm.openSelectWalletModal,
      "swap": _vm.swap,
      "resetError": _vm.resetError,
      "updateJettonFrom": _vm.updateJettonFrom,
      "updateJettonTo": _vm.updateJettonTo,
      "updateJetton": _vm.updateJetton
    }
  }, 'MintRedeemBlock', _vm.mintRedeemData, false))], 1);
};
var __vue_staticRenderFns__$2 = [];

/* style */
const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-f8b1f218_0", {
    source: "body{background:radial-gradient(at 50%,at 0,#1c1d1f 0,#1c1d1f 32%,#52545b 100%);background:radial-gradient(at 50% 0,#1c1d1f 0,#1c1d1f 32%,#52545b 100%);background-repeat:no-repeat;background-attachment:fixed;background-position:top,center;background-size:cover}main{margin-top:138px}.src-lib-components-TheDapp-header-ouSZ{max-width:1920px}.src-lib-components-TheDapp-section-1rnq{margin:24px 0;display:flex;justify-content:center}.src-lib-components-TheDapp-block-3iAA{margin:0 16px;width:480px;min-height:400px;display:flex;flex-direction:column;justify-content:center}.src-lib-components-TheDapp-icons-UjCw{display:none}.src-lib-components-TheDapp-alienIcon-B6Og{font-size:92px}.src-lib-components-TheDapp-noise-1oRB{position:absolute;top:0;width:100%;height:100%;pointer-events:none;opacity:.05;z-index:-1}@media only screen and (max-width:480px){.src-lib-components-TheDapp-icons-UjCw{display:flex;justify-content:center}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-lib-components-TheDapp-header-ouSZ",
      "section": "src-lib-components-TheDapp-section-1rnq",
      "block": "src-lib-components-TheDapp-block-3iAA",
      "icons": "src-lib-components-TheDapp-icons-UjCw",
      "alienIcon": "src-lib-components-TheDapp-alienIcon-B6Og",
      "noise": "src-lib-components-TheDapp-noise-1oRB"
    }
  });
};
/* scoped */
const __vue_scope_id__$2 = undefined;
/* module identifier */
const __vue_module_identifier__$2 = undefined;
/* functional template */
const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);
var ConnectionBlock = __vue_component__$3;var script$1 = {
  name: 'DisconnectionBlock',
  components: {
    IconSvg,
    ButtonUniversal,
    RectangularBlock
  },
  methods: {
    ...mapActions('tonConnect', ['openSelectWalletModal'])
  }
};/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('RectangularBlock', [_c('div', {
    class: _vm.$style.block
  }, [_c('IconSvg', {
    class: _vm.$style.alienIcon,
    attrs: {
      "png": "alien-hand"
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.body
  }, [_c('h2', {
    class: _vm.$style.header
  }, [_vm._v("\n        That's completely safe!\n      ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.description
  }, [_vm._v("\n        Website uses the secure TON Connect protocol. Your private keys remain securely on your device, we never have access to them.\n        The website only receives your public address, and you control every action through your wallet's manual approvals.\n      ")])]), _vm._v(" "), _c('ButtonUniversal', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.openSelectWalletModal
    }
  }, [_vm._v("\n      Connect wallet\n    ")])], 1), _vm._v(" "), _c('RectangularBlock')], 1);
};
var __vue_staticRenderFns__$1 = [];

/* style */
const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-de06630a_0", {
    source: ".src-lib-components-TheDapp-block-37gE{padding:24px 32px;display:flex;flex-direction:column;align-items:center}.src-lib-components-TheDapp-alienIcon-EudS{font-size:114px}.src-lib-components-TheDapp-body-_SCl{box-sizing:border-box;width:100%;margin:24px 0;display:flex;flex-direction:column}.src-lib-components-TheDapp-header-2dRk{margin:0;padding-bottom:8px;text-align:center;color:var(--color-info);font:var(--f-b16-mlsh)}.src-lib-components-TheDapp-description-3akA{text-align:center;color:var(--color-info);font:var(--f-14-mlsh)}.src-lib-components-TheDapp-link-3CNE{white-space:nowrap;text-decoration:underline;color:var(--color-info)}.src-lib-components-TheDapp-link-3CNE:hover{cursor:pointer}.src-lib-components-TheDapp-link-3CNE:active,.src-lib-components-TheDapp-link-3CNE:link,.src-lib-components-TheDapp-link-3CNE:visited{color:var(--color-info)}.src-lib-components-TheDapp-block-37gE button{width:100%}@media only screen and (max-width:480px){.src-lib-components-TheDapp-block-37gE{padding:24px 16px}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "block": "src-lib-components-TheDapp-block-37gE",
      "alienIcon": "src-lib-components-TheDapp-alienIcon-EudS",
      "body": "src-lib-components-TheDapp-body-_SCl",
      "header": "src-lib-components-TheDapp-header-2dRk",
      "description": "src-lib-components-TheDapp-description-3akA",
      "link": "src-lib-components-TheDapp-link-3CNE"
    }
  });
};
/* scoped */
const __vue_scope_id__$1 = undefined;
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);
var DisconnectionBlock = __vue_component__$2;var script = {
  name: 'TheDapp',
  components: {
    IconSvg,
    TheHeader,
    TheLayout,
    ConnectionBlock,
    DisconnectionBlock
  },
  data() {
    return {
      canvasId: 'noise',
      connectButtonId: 'connect-button',
      layoutColor: styleEnums.layoutColors.secondary
    };
  },
  computed: {
    ...mapGetters('tonConnect', ['isWalletConnected']),
    noiseSrvc() {
      return noiseService();
    }
  },
  async mounted() {
    this.noiseInitialize();
    await this.initialize({
      connectButtonId: this.connectButtonId,
      manifestUrl: this.$config.tonConnectManifestUri
    });
  },
  beforeDestroy() {
    this.dispose();
  },
  methods: {
    ...mapActions('tonConnect', ['initialize', 'dispose']),
    noiseInitialize() {
      this.noiseSrvc.noise(this.canvasId);
    }
  }
};/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('TheLayout', {
    attrs: {
      "background-color": _vm.layoutColor
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('TheHeader', {
          class: _vm.$style.header,
          attrs: {
            "connect-button-id": _vm.connectButtonId,
            "background-color": _vm.layoutColor
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_vm.isWalletConnected ? [_c('section', {
          class: _vm.$style.section
        }, [_c('ConnectionBlock', {
          class: _vm.$style.block
        })], 1), _vm._v(" "), _c('div', {
          class: _vm.$style.icons
        }, [_c('IconSvg', {
          class: _vm.$style.alienIcon,
          attrs: {
            "png": "alien-hand"
          }
        })], 1)] : _c('section', {
          class: _vm.$style.section
        }, [_c('DisconnectionBlock', {
          class: _vm.$style.block
        })], 1), _vm._v(" "), _c('canvas', {
          class: _vm.$style.noise,
          attrs: {
            "id": _vm.canvasId
          }
        })];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-367ca238_0", {
    source: "body{background:radial-gradient(at 50%,at 0,#1c1d1f 0,#1c1d1f 32%,#52545b 100%);background:radial-gradient(at 50% 0,#1c1d1f 0,#1c1d1f 32%,#52545b 100%);background-repeat:no-repeat;background-attachment:fixed;background-position:top,center;background-size:cover}main{margin-top:138px}.src-lib-components-header-yfUv{max-width:1920px}.src-lib-components-section-nvFN{margin:24px 0;display:flex;justify-content:center}.src-lib-components-block-2Hb0{margin:0 16px;width:480px;min-height:400px;display:flex;flex-direction:column;justify-content:center}.src-lib-components-icons-17si{display:none}.src-lib-components-alienIcon-CaUl{font-size:92px}.src-lib-components-noise-30nS{position:absolute;top:0;width:100%;height:100%;pointer-events:none;opacity:.05;z-index:-1}@media only screen and (max-width:480px){.src-lib-components-icons-17si{display:flex;justify-content:center}}",
    map: undefined,
    media: undefined
  });
  Object.defineProperty(this, "$style", {
    value: {
      "header": "src-lib-components-header-yfUv",
      "section": "src-lib-components-section-nvFN",
      "block": "src-lib-components-block-2Hb0",
      "icons": "src-lib-components-icons-17si",
      "alienIcon": "src-lib-components-alienIcon-CaUl",
      "noise": "src-lib-components-noise-30nS"
    }
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;export{__vue_component__$d as TheAnalytics,__vue_component__$1 as TheDapp,__vue_component__$u as TheLanding};